import application from 'application/application';

import moment from 'moment';

const controller = 'DefaultMovementsInssListController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'$stateParams',
	'$timeout',
	'API',
	'helper',
	'notification',
	'authentication',
	'permissions',
	// 'environment',
	// 'googleAPI',
	'downloadService',
	'integracaoGoogleCalendar', //aqui google agenda
	'$location',
	'$window',
	'filterSelect',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		$timeout,
		API,
		helper,
		notification,
		authentication,
		permissions,
		// environment,
		// googleAPI,
		downloadService,
		integracaoGoogleCalendar, //aqui google agenda
		$location,
		$window,
		filterSelect
	) => {
		$scope.stateParams = $.extend({}, $stateParams);

		// Obtém os filtros do sessionStorage e converte para objeto
		let _MODULE_MOVEMENTS_FILTERS_ = sessionStorage.getItem(
			'_MODULE_MOVEMENTS_FILTERS_'
		);
		let filters = _MODULE_MOVEMENTS_FILTERS_
			? JSON.parse(_MODULE_MOVEMENTS_FILTERS_)
			: {};

		$scope.validateEmail = /(^[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)(\s?\;\s?[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)*?$/i;

		$scope.processId = $scope.stateParams.processId;
		$scope.numeroProcesso = '';
		$scope.idProcesso = '';
		$scope.pastaProcesso = '';
		$scope.voidValue = 0;

		$scope.plural = false;

		$scope.registerAccess = JSON.parse(
			localStorage.getItem('__registerAccess__') || 'false'
		);
		$scope.createAccess = JSON.parse(
			localStorage.getItem('__createAccess__') || 'false'
		);
		$scope.accessRecords = JSON.parse(
			localStorage.getItem('__accessRecords__') || 'false'
		);

		$scope.disabledSensorsInss = false;
		$scope.disabledSensorsInssAll = false;
		$scope.enableSensorsInssAll = false;

		$scope.permissionGoogleCalendar = false;

		$scope.quickToggle = true;

		$scope.deleteProcessOptions = {
			deleteLinkedDeadlines: 1
		};

		const dataSyncGoogle = integracaoGoogleCalendar.recoverInfos();

		$rootScope.noSync =
			dataSyncGoogle && dataSyncGoogle.sincronizado ? false : true;

		$scope.showAgain = localStorage.getItem('showSyncMessage') || true;

		$rootScope.environmentNotGrid = true;

		// Data do dia em cadastrar prazo
		let defaultEmptyData = {
			_dia: moment().format('DD/MM/YYYY')
		};

		$rootScope.formCreatePrazo.taskToEdit = helper.cloneSimpleObject(
			defaultEmptyData
		);
		// list of agendas
		$scope.agendas = helper.responseStore();
		// list of event types
		$scope.eventsTypes = helper.responseStore();
		$scope.eventsNotifications = helper.responseStore();

		$scope.selectedType = null;

		// list of recurring types
		$scope.recurringEventTypes = helper.responseStore();

		// list of agenda reminder types
		$scope.agendaReminderTypes = helper.responseStore();

		// const blocked = localStorage.getItem('__authenticationUserBlocked__');

		$scope.registerINSSAccountData = {};
		$scope.showVideo = false;
		$scope.isLoadingAccessData = true;
		$scope.modalRegisterINSSAccountSuccess = false;
		$scope.disableMail = false;
		$scope.credits = {};
		$scope.creditPlanLoading = true;
		$scope.processHeader = { isLoading: false };
		$scope.processHeaderSources = {};

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		$scope.movementInAction = null;

		$scope.paginacao = {
			paginaAtual: 1,
			paginaTotal: 1,
			registrosPorPagina: 10,
			registrosTotal: 5
		};
		$scope.paginaAtual = 1;

		$scope.filterOptions = {
			documentNumber: [],
			situation: [],
			system: [],
			movementSearch: ['Ativos', 'Inativos']
		};

		$scope.processFilter = {
			inssDadoAcesso: filters.DadoAcesso ? filters.DadoAcesso : '',
			inssProcessos: { numeroProcesso: '', idProcesso: '' },
			inssSistema: filters.IdFonteXTipoPesquisa
				? filters.IdFonteXTipoPesquisa
				: '',
			inssBuscaAndamento:
				filters.IdSitPesqProcUsuarioCliente == '-7,-9'
					? 'inactive_only'
					: filters.IdSitPesqProcUsuarioCliente == -1
					? 'active_only'
					: ''
		};

		$scope.rename = {};
		$scope.pastaUsuarioCliente = null;

		if ($scope.processFilter.inssBuscaAndamento) {
			$timeout(() => {
				// Atualiza valor do model visualmente
				$('#inssBuscaAndamento')
					.val($scope.processFilter.inssBuscaAndamento)
					.trigger('change.select2');
			}, 50);
		}

		if (filters.inssProcessosCompleto) {
			$scope.processFilter.inssProcessos = {
				...filters.inssProcessosCompleto
			};
		}

		$scope.filter = {
			lido: '',
			andamento: ''
		};

		$scope.processBadges = {
			inssDadoAcesso: '',
			inssProcessos: '',
			inssSistema: '',
			inssBuscaAndamento: ''
		};

		$scope.processOrderBy = {
			TotalNaoLidos: 2,
			UltimoMovimento: 1,
			DataHoraUltSolic: 3,
			IdProcesso: 99,
			NumeroProcesso: 99,
			IdPesqProcUsuarioCliente: 99
		};

		// $scope.badgeFilterDate = helper.cloneSimpleObject($scope.stateParamsFilter);

		$scope.movementsBadges = {
			dataInicial: '',
			dataFinal: '',
			lido: '',
			andamento: ''
		};

		$scope.dateSource = {
			value: 'Todos períodos'
		};

		$scope.processesList = [];

		$scope.movements = [];

		$scope.template = {};

		$rootScope.dataSelecionada = false;

		$scope.quantityPerPage = 20;

		$scope.systemsDropdownItems = [];

		$scope.showRegisterFields = {
			login: 'disabled',
			password: 'disabled',
			qrCode: 'hidden'
		};

		$scope.itemCheckedDisable = true;

		$scope.selectAllPublicationsChecked = false;

		$scope.filtroAndamentoLista = [];
		$scope.filtroAndamentoSelecionado = {};

		$scope.disableFilterProcessButton = true;
		$scope.disableFilterMovementButton = true;

		$scope.filtroCpfLoginLista = undefined;
		$scope.filtroProcessoLista = [];
		$scope.filtroSistemaLista = [];

		$scope.blockDownload = false;

		$scope.dontShowAgainCheckbox = false;

		$scope.registerLoginErrorMessage = '';
		$scope.registerQrCodeErrorMessage = '';

		$scope.isRegisterPasswordValid = true;

		const types = [
			'identificador',
			'diario',
			'palavraChave',
			'fonte',
			'orgaoJudicial',
			'lido',
			'tipo',
			'dataInicial',
			'dataFinal',
			'composedId',
			'pesquisa',
			'caderno'
		];

		$scope.downloadMultipleMovements = false;
		$scope.isMobile = false;

		$scope.clearAll = false;
		$scope.publishEmail = [];
		$scope.saveEmail = [];
		$scope.emptyEmail = {
			email: ''
		};

		$scope.isLoadingProcesses = false;

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));
		$scope.groupUserSelected = JSON.parse(
			localStorage.getItem('__groupSelected__')
		);

		$scope.geridId = null;
		$scope.geridAccess = [];
		$scope.isChangingGerid = false;
		$scope.isRegisteringGerid = false;
		$scope.showRegisterGeridSuccess = false;

		$scope.shouldDeleteDeadlineType = 'publicação'; // publicação, andamento
		$scope.shouldDeleteDeadlineOption = 1;

		$scope.deleteMultiple = false;

		$scope.onInit = () => {
			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			} else {
				$scope.fetchDeadlineNotification();
			}
		};

		$scope.fetchDeadlineNotification = async () => {
			await $rootScope.fetchDeadlineNotificationId();

			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			}
		};

		$scope.findGeridId = () => {
			if (API.default.hostname.includes('homologacao-')) {
				$scope.geridId = 425;
			} else if (
				API.default.hostname.includes('dev-') ||
				API.default.hostname.includes('localhost')
			) {
				$scope.geridId = 425;
			} else {
				$scope.geridId = 480;
			}
		};

		$scope.findGeridId();

		$scope.fetchProcessAccessData = () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			if (record) {
				$scope.parameterUsers = record;

				/***************** GRID Variáveis **********************/
				$rootScope.grid =
					$scope.parameterUsers.idTipoVisualizacao == -1 ? false : true;
				$scope.exibirInfosGrid = $scope.parameterUsers.exibirInfo;
				/******************************************************/

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				$scope.quantityPerPage = $scope.parameterUsers.qtdRegistroMovPorPagina
					? $scope.parameterUsers.qtdRegistroMovPorPagina
					: 20;
			}

			let paginaAtual = 1;

			const urlParams = $location.$$url.split('?')[1];

			if ($scope.processId) {
				if (urlParams) {
					const pages = urlParams.split('&');

					pages.forEach(page => {
						const parameter = page.split('=');

						if (parameter[0] && parameter[1] && parameter[0] == 'paginaAtual') {
							paginaAtual = parameter[1];
						}

						return 1;
					});
				}

				if (urlParams) {
					const pages = urlParams.split('&');

					pages.forEach(page => {
						const parameter = page.split('=');

						if (
							parameter[0] &&
							parameter[1] &&
							parameter[0] == 'numeroProcesso'
						) {
							$scope.numeroProcesso = parameter[1];
						}
						if (parameter[0] && parameter[1] && parameter[0] == 'idProcesso') {
							$scope.idProcesso = parameter[1];
						}
						if (
							parameter[0] &&
							parameter[1] &&
							parameter[0] == 'pastaProcesso'
						) {
							$scope.pastaProcesso = parameter[1];
						}
						if (
							!$rootScope.dateMovements ||
							$rootScope.dateMovements.length < 1
						) {
							$rootScope.dateMovements = [];
						}
						if (parameter[0] && parameter[1] && parameter[0] == 'dataInicial') {
							$scope.filter.dataInicial = parameter[1];
							$rootScope.dateMovements[0] = parameter[1];
						}
						if (parameter[0] && parameter[1] && parameter[0] == 'dataFinal') {
							$scope.filter.dataFinal = parameter[1];
							$rootScope.dateMovements[1] = parameter[1];
						}
						if (parameter[0] && parameter[1] && parameter[0] == 'lido') {
							$scope.filter.lido = parameter[1];
						}
						if (parameter[0] && parameter[1] && parameter[0] == 'andamento') {
							$scope.filter.andamento = parameter[1];
						}
					});

					if ($scope.filter.dataInicial && $scope.filter.dataFinal) {
						const formattedDate =
							moment(new Date($scope.filter.dataInicial)).format('DD/MM/YYYY') +
							' até ' +
							moment(new Date($scope.filter.dataFinal)).format('DD/MM/YYYY');

						$scope.dateSource = {
							value: formattedDate
						};
					}
				}

				//Se houver process Id na url
				const idClienteXFontePesqProc = $scope.processId;

				const paramsSearch = {
					idClienteXFontePesqProc,
					paginaAtual,
					registrosPorPagina: $scope.quantityPerPage,
					ordenacao: 'UltimoMovimento',
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				};

				if ($scope.filter.lido) {
					paramsSearch.FlLido = $scope.filter.lido == 'lidos' ? true : false;
					$scope.movementsBadges.lido =
						$scope.filter.lido == 'lidos' ? 'Lidos' : 'Não Lidos';
				} else {
					$scope.movementsBadges.lido = '';
				}

				if ($scope.filter.dataInicial && $scope.filter.dataFinal) {
					paramsSearch.DataHoraAndProcessoInicio = $scope.filter.dataInicial;
					paramsSearch.DataHoraAndProcessoFim = $scope.filter.dataFinal;
					$scope.movementsBadges.dataInicial = $scope.filter.dataInicial;
					$scope.movementsBadges.dataFinal = $scope.filter.dataFinal;
				} else {
					$scope.movementsBadges.dataInicial = '';
					$scope.movementsBadges.dataFinal = '';
				}

				if ($scope.filter.andamento) {
					paramsSearch.IdTipoAndamentoProcesso = $scope.filter.andamento;
					$scope.filtroAndamentoLista.map(item => {
						if (item.id == $scope.filter.andamento) {
							$scope.movementsBadges.andamento = item.nome;
						}
					});
				} else {
					$scope.movementsBadges.andamento = '';
				}

				$scope.isLoadingAccessData = true;

				$http({
					...helper.http(API.sourceAccessData, 'movements'),
					method: 'GET',
					params: paramsSearch
				})
					.then(response => {
						$scope.movements = response.data.itens;
						$scope.processesList = response.data.itens;
						$scope.paginacao = response.data.paginacao;
						$scope.isMobile =
							window && window.innerWidth && window.innerWidth <= 991
								? true
								: false;

						$scope.isLoadingAccessData = false;

						const hasItems =
							response.data.itens && response.data.itens.length > 0;

						$scope.hasNotListDetails = !hasItems;

						if ($scope.movements.length > 0) $scope.permissionsUserClient();

						const movInss = response.data.itens.map(element => ({
							idMovProcUsuarioCliente: element.idMovProcUsuarioCliente
						}));

						sessionStorage.setItem('movementsINSS', JSON.stringify(movInss));
						sessionStorage.setItem(
							'page-movementsINSS',
							JSON.stringify(response.data.paginacao)
						);

						if ($scope.isMobile && $scope.processesList.length === 0) {
							setTimeout(() => {
								window.scrollTo({
									top: document.body.scrollHeight,
									behavior: 'smooth' // Para um efeito suave
								});
							}, 500);
						}
					})
					.catch(() => {
						$scope.isLoadingAccessData = false;
					});
			} else {
				const paramsSearch = {
					paginaAtual: $scope.paginaAtual,
					registrosPorPagina: $scope.quantityPerPage,
					ordenacao: 'UltimoMovimento',
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				};

				if ($scope.processFilter.inssDadoAcesso) {
					paramsSearch.DadoAcesso = $scope.processFilter.inssDadoAcesso;
				}
				if ($scope.processFilter.inssProcessos) {
					paramsSearch.IdProcesso =
						$scope.processFilter.inssProcessos.idProcesso;
					paramsSearch.NumeroProcesso =
						$scope.processFilter.inssProcessos.numeroProcesso;
				}
				if ($scope.processFilter.inssSistema) {
					paramsSearch.IdFonteXTipoPesquisa = $scope.processFilter.inssSistema;
				}
				if ($scope.processFilter.inssBuscaAndamento) {
					paramsSearch.IdSitPesqProcUsuarioCliente =
						$scope.processFilter.inssBuscaAndamento == 'active_only'
							? -1
							: '-7,-9';
				}

				paramsSearch.ordenacao = '';

				for (let i = 1; i < 3; i++) {
					for (const [key] of Object.entries($scope.processOrderBy)) {
						if ($scope.processOrderBy[key] == i) {
							paramsSearch.ordenacao += paramsSearch.ordenacao == '' ? '' : ',';
							paramsSearch.ordenacao += key;
						}
						if ($scope.processOrderBy[key] == i * -1) {
							paramsSearch.ordenacao += paramsSearch.ordenacao == '' ? '' : ',';
							paramsSearch.ordenacao += '-' + key;
						}
					}
				}

				$scope.isLoadingAccessData = true;

				$http({
					...helper.http(API.sourceAccessData, 'process'),
					method: 'GET',
					params: paramsSearch
				})
					.then(processData => {
						const hasItems =
							processData.data.itens && processData.data.itens.length > 0;

						$scope.hasNotList = !hasItems;

						$scope.processesList = processData.data.itens;

						$scope.paginacao = processData.data.paginacao;

						$scope.isMobile =
							window && window.innerWidth && window.innerWidth <= 991
								? true
								: false;

						$scope.isLoadingAccessData = false;

						if ($scope.isMobile && $scope.processesList.length === 0) {
							setTimeout(() => {
								window.scrollTo({
									top: document.body.scrollHeight,
									behavior: 'smooth'
								});
							}, 500);
						}
					})
					.finally(() => {
						$scope.processFilter = {
							inssDadoAcesso: paramsSearch.DadoAcesso,
							inssProcessos: {
								numeroProcesso: paramsSearch.NumeroProcesso,
								idProcesso: paramsSearch.IdProcesso
							},
							inssSistema: paramsSearch.IdFonteXTipoPesquisa,
							inssBuscaAndamento:
								paramsSearch.IdSitPesqProcUsuarioCliente == -1
									? 'active_only'
									: paramsSearch.IdSitPesqProcUsuarioCliente == '-7,-9'
									? 'inactive_only'
									: ''
						};

						$scope.isLoadingAccessData = false;
					});
			}

			$scope.accessRecords = JSON.parse(
				localStorage.getItem('__accessRecords__') || 'false'
			);
		};

		$scope.fetchGeridAccess = () => {
			$scope.geridAccess = [];
			const paramsSearch = {
				paginaAtual: 1,
				registrosPorPagina: 100,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null,
				idFonteXTipoPesquisa: $scope.geridId
			};

			$http({
				...helper.http(API.sourceAccessData, 'GET'),
				method: 'GET',
				params: paramsSearch
			}).then(response => {
				if (
					response.data &&
					response.data.itens &&
					response.data.itens.length > 0
				) {
					for (let item in response.data.itens) {
						$scope.geridAccess.push(response.data.itens[item]);
					}
				}
			});
		};

		$scope.fetchProcessFilters = () => {
			const paramsSearch = {
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			if ($scope.geridAccess.length == 0) {
				$scope.fetchGeridAccess();
			}

			if (!$scope.processId) {
				//Opções do CPF/Login
				$http({
					...helper.http(API.sourceAccessData, 'GET'),
					method: 'GET',
					params: paramsSearch
				}).then(response => {
					if (
						response &&
						response.status == 200 &&
						response.data &&
						response.data.itens
					) {
						const uniqueItems = [];
						const dadoAcessoCadastrados = [];

						$scope.filtroCpfLoginLista = [];

						response.data.itens.forEach(item => {
							if (!dadoAcessoCadastrados.includes(item.dadoAcesso)) {
								uniqueItems.push(item);
								dadoAcessoCadastrados.push(item.dadoAcesso);
							}
						});

						$scope.filtroCpfLoginLista = uniqueItems;
					}
				});

				//Opções de Processos

				// $http({
				// 	...helper.http(API.searchFontsProcess, 'processFilter'),
				// 	method: 'GET'
				// }).then(response => {
				// 	if (
				// 		response &&
				// 		response.status == 200 &&
				// 		response.data &&
				// 		response.data.itens
				// 	) {
				// 		$scope.filtroProcessoLista = response.data.itens;
				// 		$rootScope.newPublicationChecked = [];
				// 	}
				// });

				//Opções de Sistemas

				$http({
					...helper.http(API.searchFontsProcess, 'GET'),
					params: {
						IdClassificacaoInstituicao: -2
					},
					method: 'GET'
				})
					.then(response => {
						if (
							response &&
							response.status == 200 &&
							response.data &&
							response.data.itens
						) {
							$scope.filtroSistemaLista = response.data.itens;
						}
					})
					.finally(() => {
						$timeout(() => {
							// Atualiza valor do model visualmente
							$('#inssSistema')
								.val($scope.processFilter.inssSistema)
								.trigger('change.select2');

							$scope.filtroSistemaLista.map(item => {
								if (
									item.idFonteXTipoPesquisa == $scope.processFilter.inssSistema
								) {
									$scope.processBadges.inssSistema = item.fontePesquisa;
								}
							});
						}, 50);
					});
			}
		};

		$scope.initProcesses = () => {
			//Opções de Processos
			if (!$scope.filtroProcessoLista.length) {
				$http({
					...helper.http(API.searchFontsProcess, 'processFilter'),
					method: 'GET'
				}).then(response => {
					if (
						response &&
						response.status == 200 &&
						response.data &&
						response.data.itens
					) {
						$scope.filtroProcessoLista = response.data.itens;
						$rootScope.newPublicationChecked = [];
					}
				});
			}
		};

		$scope.fetchMovementsFilters = event => {
			event.preventDefault();
			event.stopPropagation();

			if ($scope.processId) {
				$http({
					...helper.http(API.inssFilter, 'movementStatus'),
					method: 'GET'
				}).then(response => {
					if (
						response &&
						response.status === 200 &&
						response.data &&
						response.data.itens
					) {
						$scope.filtroAndamentoLista = response.data.itens;

						const $select = $('#andamento');

						$select.select2('close');

						setTimeout(() => {
							$select.select2('open');
						});
					}
				});
			}
		};

		$scope.fetchProcessAccessData();
		$scope.fetchProcessFilters();
		// $scope.fetchMovementsFilters();

		$scope.changeRegisterSystem = system => {
			if ($scope.geridId == system.idFonteXTipoPesquisa) {
				$scope.isChangingGerid = true;
			} else {
				$scope.isChangingGerid = false;
			}

			let newRegisterFields = {
				login: 'disabled',
				password: 'disabled',
				qrCode: 'hidden'
			};

			if (
				system &&
				system.tipoAcessoFontePesquisas &&
				system.tipoAcessoFontePesquisas[0]
			) {
				system.tipoAcessoFontePesquisas.forEach(id => {
					switch (id.idTipoAcessoFontePesq) {
						case -1:
							newRegisterFields = {
								...newRegisterFields,
								login: 'show',
								password: 'show'
							};
							break;
						case -2:
							newRegisterFields = {
								...newRegisterFields,
								qrCode: 'show'
							};
							break;
					}
				});
			}
			$scope.showRegisterFields = newRegisterFields;

			setTimeout(() => {
				if (!$scope.isMobile) {
					const inputElement = document.getElementById('inputLoginText');

					if (inputElement) {
						inputElement.focus();
					}
				} else {
					const inputElement = document.getElementById('inputLoginTextMobile');

					if (inputElement) {
						inputElement.focus();
					}
				}
			}, 100);
		};

		$scope.resetFilter = (filterName, reload = false, dateArr = null) => {
			switch (filterName) {
				case 'inssDadoAcesso':
					$scope.processFilter.inssDadoAcesso = '';
					if (reload) $scope.filterProcess($scope.processFilter);
					break;
				case 'inssProcessos':
					$scope.processFilter.inssProcessos = {
						numeroProcesso: '',
						idProcesso: ''
					};
					if (reload) $scope.filterProcess($scope.processFilter);
					break;
				case 'inssSistema':
					$scope.processFilter.inssSistema = '';
					$scope.clearFilter($scope.processFilter, ['inssSistema']);
					if (reload) $scope.filterProcess($scope.processFilter);
					break;
				case 'inssBuscaAndamento':
					$scope.processFilter.inssBuscaAndamento = '';
					$scope.clearFilter($scope.processFilter, ['inssBuscaAndamento']);
					if (reload) $scope.filterProcess($scope.processFilter);
					break;
				case 'all':
					$scope.clearFilter($scope.processFilter, ['inssSistema']);
					$scope.clearFilter($scope.processFilter, ['inssBuscaAndamento']);
					$scope.processFilter = {
						inssDadoAcesso: '',
						inssProcessos: { numeroProcesso: '', idProcesso: '' },
						inssSistema: '',
						inssBuscaAndamento: ''
					};
					if (reload) $scope.filterProcess($scope.processFilter);
					break;
				case 'movementsData':
					$scope.dateSource = {
						value: 'Todos períodos'
					};
					$scope.changedPeriods(dateArr, true);
					if (reload) $scope.filterMovements($scope.filter);
					break;
				case 'movementsLido':
					$scope.clearFilter($scope.filter, ['lido']);
					if (reload) $scope.filterMovements($scope.filter);
					break;
				case 'movementsAndamento':
					$scope.clearFilter($scope.filter, ['andamento']);
					if (reload) $scope.filterMovements($scope.filter);
					break;
				case 'movementsAll':
					$scope.changedPeriods(dateArr, true);
					$scope.clearFilter($scope.filter, ['lido']);
					$scope.clearFilter($scope.filter, ['andamento']);
					if (reload) $scope.filterMovements($scope.filter);
					break;
			}
			$scope.selectedFilter();
			// $scope.filterProcess($scope.processFilter);
		};

		$scope.onCPFInputChange = () => {
			$scope.registerLoginErrorMessage = '';

			if (
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.login &&
				$scope.registerINSSAccountData.login.length - 3 == 11
			) {
				let isCPFValid = helper.validateCPF(
					$scope.registerINSSAccountData.login
				);

				if (!isCPFValid) {
					$scope.registerLoginErrorMessage = 'CPF inválido.';
				} else {
					const inputElement = document.getElementById('inputPassword');

					if (inputElement) {
						inputElement.focus();
					}
				}
			}
		};

		$scope.onPasswordInputChange = () => {
			$scope.isRegisterPasswordValid = true;
		};

		$scope.onCpfInputBlur = () => {
			if (
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.login &&
				$scope.registerINSSAccountData.login.length > 0
			) {
				let isCPFValid = helper.validateCPF(
					$scope.registerINSSAccountData.login
				);

				if (!isCPFValid) {
					$scope.registerLoginErrorMessage = 'CPF inválido.';
				}
			} else {
				$scope.registerLoginErrorMessage = 'Campo obrigatório.';
			}
		};

		$scope.onPasswordBlur = () => {
			const isPasswordValid =
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.password &&
				$scope.registerINSSAccountData.password.length > 0;

			if (!isPasswordValid) {
				$scope.isRegisterPasswordValid = false;
			}
		};

		$scope.registerINSSAccount = data => {
			let hasError = false;

			if (
				!(
					data.login &&
					data.password &&
					$scope.showRegisterFields.qrCode == 'hidden'
				) &&
				!(data.login && data.password && data.qr_code)
			) {
				hasError = true;
			}

			if (!(data.login && data.login.length > 0)) {
				$scope.registerLoginErrorMessage = 'Campo obrigatório.';
				hasError = true;
			}

			const isCPFValid = helper.validateCPF(data.login);
			const isPasswordValid = data.password.length > 0;

			if (!isCPFValid && data.login.length > 0) {
				hasError = true;
				$scope.registerLoginErrorMessage = 'CPF inválido.';

				setTimeout(() => {
					if (!$scope.isMobile) {
						const inputElement = document.getElementById('inputLoginText');

						if (inputElement) inputElement.focus();
					} else {
						const inputElement = document.getElementById(
							'inputLoginTextMobile'
						);

						if (inputElement) inputElement.focus();
					}
				}, 100);
			}

			if (!isPasswordValid) {
				hasError = true;
				$scope.isRegisterPasswordValid = false;

				setTimeout(() => {
					if (!$scope.isMobile) {
						const inputElement = document.getElementById('inputPassword');

						if (inputElement) inputElement.focus();
					} else {
						const inputElement = document.getElementById('inputPasswordMobile');

						if (inputElement) inputElement.focus();
					}
				}, 100);
			}

			if (hasError) return;

			$scope.disableMail = true;

			const itens = [
				{
					idFonteXTipoPesquisa: data.select.idFonteXTipoPesquisa,
					dadoAcesso: data.login,
					senha: data.password,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			];

			if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
				$scope.isRegisteringGerid = true;
			} else {
				$scope.isRegisteringGerid = false;
				$scope.showRegisterGeridSuccess = false;
			}

			if (data.qr_code && $scope.showRegisterFields.qrCode != 'hidden') {
				itens[0].autenticacao = data.qr_code;
			}

			$http({
				...helper.http(API.sourceAccessData, 'POST'),
				method: 'POST',
				data: { itens },
				messageOverride: { error() {} }
			})
				.then(() => {
					if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
						$scope.fetchGeridAccess();
						$scope.showRegisterGeridSuccess = true;
					}

					localStorage.setItem('__registerAccess__', JSON.stringify(true));
					localStorage.setItem('__createAccess__', JSON.stringify(true));
					localStorage.setItem('__accessRecords__', JSON.stringify(true));

					$scope.registerAccess = JSON.parse(
						localStorage.getItem('__registerAccess__') || 'false'
					);
					$scope.createAccess = JSON.parse(
						localStorage.getItem('__createAccess__') || 'false'
					);
					$scope.accessRecords = JSON.parse(
						localStorage.getItem('__accessRecords__') || 'false'
					);

					$scope.modalRegisterINSSAccountSuccess = true;

					setTimeout(() => {
						if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
							$scope.isRegisteringGerid = true;
						} else {
							$scope.isRegisteringGerid = false;
							$scope.showRegisterGeridSuccess = false;
						}
						$scope.disableMail = false;

						let dontShowSuccessRegisterModalAgain = localStorage.getItem(
							'__dontShowSuccessRegisterModalAgain__'
						);

						if (
							dontShowSuccessRegisterModalAgain == null ||
							dontShowSuccessRegisterModalAgain == undefined ||
							dontShowSuccessRegisterModalAgain == false ||
							dontShowSuccessRegisterModalAgain == 'false' ||
							$scope.geridId == itens[0].idFonteXTipoPesquisa
						) {
							$scope.modalRegisterINSSAccountSuccess = true;
						} else {
							$scope.closeModal('#modalRegisterINSSAccount');
						}

						$scope.fetchProcessFilters();

						if ($scope.$$phase !== '$apply' && $scope.$$phase !== '$digest') {
							$scope.$apply();
						}
					}, 100);
				})
				.catch(error => {
					if (
						error.data &&
						error.data.status &&
						error.data.status.erros &&
						error.data.status.erros[0]
					) {
						let errorMessage = error.data.status.erros[0].mensagem;

						if (errorMessage.contains('Erro ao cadastrar dados de acesso. ')) {
							errorMessage = errorMessage.split(
								'Erro ao cadastrar dados de acesso. '
							)[1];
						}

						$scope.registerQrCodeErrorMessage = errorMessage;
					}
				})
				.finally(() => {
					$scope.disableMail = false;
					$scope.isRegisteringGerid = false;
				});
		};

		$scope.resetQRCodeErrorMessage = () => {
			$scope.registerQrCodeErrorMessage = '';
		};

		$scope.openUrl = url => {
			window.open(url, '_blank');
		};

		$scope.openModal = modalId => {
			$scope.isChangingGerid = false;
			$scope.isRegisteringGerid = false;
			$scope.showRegisterGeridSuccess = false;

			if (modalId == '#modalRegisterINSSAccount') {
				if ($scope.systemsDropdownItems.length == 0) {
					$scope.fetchSearchSources();
				}

				$scope.modalRegisterINSSAccountSuccess = false;
				$scope.registerINSSAccountData = {};
				$scope.showRegisterFields = {
					login: 'disabled',
					password: 'disabled',
					qrCode: 'hidden'
				};

				$scope.registerLoginErrorMessage = '';
				$scope.registerQrCodeErrorMessage = '';

				$scope.isRegisterPasswordValid = true;
			}

			setTimeout(() => {
				$(modalId).modal('show');
			}, 300);
		};

		$scope.openModalEmail = params => {
			$scope.paramsModalEmail = params;
			$rootScope.configSendEmail.action = params;
			$rootScope.configSendEmail.route = 'movements';
			$rootScope.configSendEmail.calcelModaLidos = true;
			$rootScope.configSendEmail.title = 'Enviar por email';

			const el = $('#modalSendEmailComponent');

			el.modal && el.modal('show');
		};

		$scope.openGenericModal = (movement, id, action, fn = () => {}) => {
			$scope.isChangingGerid = false;
			$scope.isRegisteringGerid = false;
			$scope.showRegisterGeridSuccess = false;
			$scope.deleteProcessOptions = {
				deleteLinkedDeadlines: 1
			};

			$scope.plural = movement.length > 1 ? true : false;

			if (action) $scope.movementInAction = movement;
			fn;

			if (id == '#modalDeleteMovementNew') {
				$rootScope.getDaysDeleteTrash();

				if (movement && !movement.length) {
					$scope.deleteMultiple = false;
					if (movement.prazosAVencer || movement.prazosVencidos) {
						id = '#modalDeleteMovementWithDeadline';
					}
				} else {
					$scope.deleteMultiple = true;
					for (let i = 0; i < movement.length; i++) {
						if (
							movement[i].prazosAVencer ||
							movement[i].prazosAvencer ||
							movement[i].prazosVencidos
						) {
							id = '#modalDeleteMovementWithDeadline';
						}
					}
				}
			}

			if (id == '#modalSendEmailComponent') {
				$rootScope.configSendEmail.action = movement;
				$rootScope.configSendEmail.route = 'movements';
				$rootScope.configSendEmail.title = 'Enviar por email';
			}

			if (id == '#modalRenameProcess') {
				$scope.$resetFormValidation('renameProcessesForm')();

				let folderItem = $scope.$parent.$$prevSibling.processMovements.items.find(
					item => item.id === +$stateParams.pasta
				);

				$scope.rename.nome =
					folderItem && folderItem.nome ? folderItem.nome : $scope.rename.nome;

				$(id).one('shown.bs.modal', () => {
					const renameInput = document.getElementById('renameProcess');

					if (renameInput) renameInput.focus();
				});
			}

			setTimeout(() => {
				$(id).modal('show');
			}, 300);

			$scope.handleClick();
		};

		$scope.closeModal = id => {
			$(id).modal('hide');
		};

		$scope.sendToTrashCan = (movements, request) => {
			if ($scope.restore || $scope.send) return;

			request == 'restore' ? ($scope.restore = true) : ($scope.send = true);

			let objData = [];
			let allChecked = false;

			if (movements) {
				movements.forEach(item => {
					objData.push({
						idPasta:
							item.idPasta ||
							item.idPastaUsuarioCliente ||
							$scope.pastaProcesso,
						idMovimentoProcessoCliente: item.idMovProcessoCliente,
						idUsuarioCliente: item.idUsuarioCliente,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						excluirPrazosVinculados: !!($scope.shouldDeleteDeadlineOption == 2)
					});
				});
			}

			if (
				$('#movement-checkbox-all').prop('indeterminate') == false &&
				$('#movement-checkbox-all').prop('checked') == true
			) {
				allChecked = true;
			}

			if (objData.length > 0) {
				$http({
					...helper.http(API.trashCan, `${request}`),
					method: 'PUT',
					data: objData,
					messageOverride: {
						success(response, notify) {
							const success =
								request == 'send'
									? 'Enviado para a Lixeira!'
									: 'Documento restaurado!';

							notify.success(success);
						},
						error(response, notify) {
							const error =
								request == 'send'
									? 'Erro ao enviar para Lixeira.'
									: 'Erro ao restaurar documento.';

							notify.danger(error);
						}
					}
				})
					.then(response => {
						if (response.status != 500) {
							if (response.status == 200) {
								const itens = response.data.itens;

								for (let i = $scope.movements.length - 1; i >= 0; i--) {
									if (
										itens.some(
											item =>
												item.idMovProcessoCliente ===
												$scope.movements[i].idMovProcessoCliente
										)
									) {
										$scope.movements.splice(i, 1);
									}
								}
							}
						} else if (response.status == 500) {
							request == 'send' &&
								notification.danger('Erro ao enviar para Lixeira.');
						}
					})
					.finally(() => {
						if (
							$scope.movements &&
							$scope.movements.length > 0 &&
							$rootScope.newPublicationChecked &&
							$rootScope.newPublicationChecked.length > 0
						) {
							$scope.movements.forEach(item => {
								item.__checked__ = false;
								$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
									value =>
										item.idMovProcessoCliente !== value.idMovProcessoCliente
								);
							});
						}

						$rootScope.newPublicationChecked = [];
						$('#movement-checkbox-all').prop('indeterminate', false);
						$('#movement-checkbox-all').prop('checked', false);

						$scope.itemCheckedDisable = true;

						$scope.closeModal('#modalDeleteMovementNew');
						$scope.closeModal('#modalDeleteMovementWithDeadline');

						$scope.send = false;

						if (allChecked) {
							$scope.changePage('first');
						} else {
							if (
								!$scope.movements ||
								($scope.movements && $scope.movements.length == 0)
							) {
								$location.search({});

								$rootScope.dateMovements = [];
								$scope.filter = {};
								$location.reload();

								return;
							}

							let paginaAtual = 1;

							//Se houver process Id na url
							const idClienteXFontePesqProc = $scope.processId;

							const paramsSearch = {
								idClienteXFontePesqProc,
								paginaAtual,
								registrosPorPagina: $scope.quantityPerPage,
								ordenacao: 'UltimoMovimento',
								idGrupoUsuarios:
									$scope.groupUserSelected && $scope.groupData
										? $scope.groupData.idGrupo
										: null
							};

							if ($scope.filter.lido) {
								paramsSearch.FlLido =
									$scope.filter.lido == 'lidos' ? true : false;
								$scope.movementsBadges.lido =
									$scope.filter.lido == 'lidos' ? 'Lidos' : 'Não Lidos';
							} else {
								$scope.movementsBadges.lido = '';
							}

							if ($scope.filter.dataInicial && $scope.filter.dataFinal) {
								paramsSearch.DataHoraAndProcessoInicio =
									$scope.filter.dataInicial;
								paramsSearch.DataHoraAndProcessoFim = $scope.filter.dataFinal;
								$scope.movementsBadges.dataInicial = $scope.filter.dataInicial;
								$scope.movementsBadges.dataFinal = $scope.filter.dataFinal;
							} else {
								$scope.movementsBadges.dataInicial = '';
								$scope.movementsBadges.dataFinal = '';
							}

							if ($scope.filter.andamento) {
								paramsSearch.IdTipoAndamentoProcesso = $scope.filter.andamento;
								$scope.filtroAndamentoLista.map(item => {
									if (item.id == $scope.filter.andamento) {
										$scope.movementsBadges.andamento = item.nome;
									}
								});
							} else {
								$scope.movementsBadges.andamento = '';
							}

							$scope.isLoadingAccessData = true;

							$http({
								...helper.http(API.sourceAccessData, 'movements'),
								method: 'GET',
								params: paramsSearch
							})
								.then(response => {
									$scope.movements = response.data.itens;
									$scope.processesList = response.data.itens;
									$scope.paginacao = response.data.paginacao;
									$scope.isMobile =
										window && window.innerWidth && window.innerWidth <= 991
											? true
											: false;

									$scope.isLoadingAccessData = false;
								})
								.catch(() => {
									$scope.isLoadingAccessData = false;
								});

							$rootScope.newPublicationChecked = [];
							$('#movement-checkbox-all').prop('indeterminate', false);
							$('#movement-checkbox-all').prop('checked', false);
						}
					});
			}
		};

		$scope.renameProcesses = process => {
			$scope.printing = true;

			$http({
				...helper.http(API.briefcase, 'PUT'),
				data: {
					itens: [
						{
							id: $scope.pastaProcesso,
							nome: process.nome == '' ? null : process.nome
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Processo renomeado! ');
					}
				}
			}).then(() => {
				sessionStorage.setItem('__pageMovements__', 1);
				$scope.itemCheckedDisable = true;
				$scope.printing = false;

				$scope.pastaUsuarioCliente = process.nome;

				$('#modalRenameProcess').modal('hide');
			});
		};

		$scope.setDeleteModal = (movement, isProcess = false) => {
			if (isProcess && typeof movement == 'string') {
				const paramsSearch = {
					paginaAtual: 1,
					IdProcesso: movement,
					registrosPorPagina: $scope.quantityPerPage,
					ordenacao: 'UltimoMovimento',
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				};

				if ($scope.processFilter.inssDadoAcesso) {
					paramsSearch.DadoAcesso = $scope.processFilter.inssDadoAcesso;
				}
				if ($scope.processFilter.inssProcessos) {
					paramsSearch.IdProcesso =
						$scope.processFilter.inssProcessos.idProcesso;
					paramsSearch.NumeroProcesso =
						$scope.processFilter.inssProcessos.numeroProcesso;
				}
				if ($scope.processFilter.inssSistema) {
					paramsSearch.IdFonteXTipoPesquisa = $scope.processFilter.inssSistema;
				}
				if ($scope.processFilter.inssBuscaAndamento) {
					paramsSearch.IdSitPesqProcUsuarioCliente =
						$scope.processFilter.inssBuscaAndamento == 'active_only'
							? -1
							: '-7,-9';
				}

				paramsSearch.ordenacao = '';

				for (let i = 1; i < 3; i++) {
					for (const [key] of Object.entries($scope.processOrderBy)) {
						if ($scope.processOrderBy[key] == i) {
							paramsSearch.ordenacao += paramsSearch.ordenacao == '' ? '' : ',';
							paramsSearch.ordenacao += key;
						}
						if ($scope.processOrderBy[key] == i * -1) {
							paramsSearch.ordenacao += paramsSearch.ordenacao == '' ? '' : ',';
							paramsSearch.ordenacao += '-' + key;
						}
					}
				}

				$http({
					...helper.http(API.sourceAccessData, 'process'),
					method: 'GET',
					params: paramsSearch
				})
					.then(processData => {
						const processItens = processData.data.itens;

						if (processItens && processItens.length == 1) {
							$scope.movementInAction = [];
							$scope.movementInAction.push(processItens[0]);
						}
					})
					.finally(() => {
						$scope.processFilter = {
							inssDadoAcesso: paramsSearch.DadoAcesso,
							inssProcessos: {
								numeroProcesso: paramsSearch.NumeroProcesso,
								idProcesso: paramsSearch.IdProcesso
							},
							inssSistema: paramsSearch.IdFonteXTipoPesquisa,
							inssBuscaAndamento:
								paramsSearch.IdSitPesqProcUsuarioCliente == -1
									? 'active_only'
									: paramsSearch.IdSitPesqProcUsuarioCliente == '-7,-9'
									? 'inactive_only'
									: ''
						};
					});
			} else {
				$scope.movementInAction = [];

				!movement[0]
					? $scope.movementInAction.push(movement)
					: ($scope.movementInAction = [...$rootScope.newPublicationChecked]);
			}
		};

		$scope.toggleKeepUpdated = processCard => {
			let idsFontesProcesso = [];
			let idSituacaoPesquisaProcesso =
				processCard.idSitPesqProcUsuarioCliente == -1 ? -7 : -1;

			processCard.fontesProcesso.forEach(source => {
				idsFontesProcesso.push(source.idFonteProcesso);
			});

			$http({
				...helper.http(API.inssProcessHeader, 'updateAutomaticSource'),
				method: 'PUT',
				data: {
					itens: [
						{
							idsFontesProcesso,
							idSituacaoPesquisaProcesso,
							idGrupoUsuarios:
								$scope.groupUserSelected && $scope.groupData
									? $scope.groupData.idGrupo
									: null
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Busca de andamentos atualizada com sucesso!');
					}
				}
			}).then(response => {
				const { data } = response;

				if (data.status && data.status.codigo == 200) {
					processCard.idSitPesqProcUsuarioCliente = idSituacaoPesquisaProcesso;
				}
			});
		};

		$scope.fetchProcessHeader = () => {
			$scope.processHeader.isLoading = true;

			if ($scope.processId) {
				const params = {
					IdClienteXFontePesqProc: $scope.processId,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				};

				$http({
					...helper.http(API.inssProcessHeader, 'detail'),
					method: 'GET',
					params
				})
					.then(response => {
						const data = response.data;

						if (data && data.status.codigo == 200) {
							data.itens.forEach(item => {
								if (item.pastaUsuarioCliente) {
									$scope.pastaUsuarioCliente = item.pastaUsuarioCliente;
									$scope.rename.nome = item.pastaUsuarioCliente;
								}

								item.fontesProcesso.forEach(fonte => {
									fonte.mostrarFonte = false;
								});
							});

							$scope.processHeader = data.itens;
						}
					})
					.finally(() => {
						$scope.processHeader.isLoading = false;
					});
			}
		};

		$scope.fetchProcessHeaderSources = source => {
			const params = {
				IdFonteProcesso: source.idFonteProcesso,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			$http({
				...helper.http(API.inssProcessHeader, 'GET'),
				method: 'GET',
				params
			})
				.then(response => {
					const data = response.data;

					if (data && data.status.codigo == 200) {
						$scope.processHeaderSources = data.itens;
					}
				})
				.finally(() => {
					$scope.processHeader.isLoading = false;
				});
		};

		$scope.fetchProcessHeader();

		$scope.showProcessSource = (source, newStatus) => {
			if (newStatus) {
				$scope.processHeader.isLoading = true;
				$scope.fetchProcessHeaderSources(source);
			}

			source.mostrarFonte = newStatus;
		};

		$scope.openProcessFolder = process => {
			$rootScope.dateArr = [];
			$rootScope.dateMovements = [];
			$rootScope.params && ($rootScope.params.dataInicial = null);
			$rootScope.params && ($rootScope.params.dataFinal = null);

			if (process.idClienteXFontePesqProc) {
				$state.go(
					'root.default.movements.inss1',
					{
						processId: process.idClienteXFontePesqProc,
						numeroProcesso: process.numeroProcesso,
						idProcesso: process.idProcesso,
						pastaProcesso: process.idPastaUsuarioCliente
					},
					{
						inherit: false,
						reload: true
					}
				);
			}

			return process;
		};

		$scope.goToInssDetails = movement => {
			let params = {
				movements: movement.idMovProcUsuarioCliente
			};

			if ($scope.processId && $scope.processId.length > 0) {
				params.pasta = $scope.processId;
			}
			if ($scope.numeroProcesso) {
				params.numeroProcesso = $scope.numeroProcesso;
			}
			if ($scope.idProcesso) {
				params.idProcesso = $scope.idProcesso;
			}
			if ($scope.pastaProcesso) {
				params.pastaProcesso = $scope.pastaProcesso;
			}

			$state.go('root.default.movements.inssDetails', params, {
				inherit: false,
				reload: 'root.default.movements.inssDetails'
			});
		};

		$scope.goToAccessManager = () => {
			$state.go('root.default.inssManager', {
				inherit: false,
				reload: true
			});
		};

		$scope.returnSummary = summary => {
			return summary;
		};

		$scope.allPeriods = clear => {
			const e = document.getElementById('air-datepicker-range');

			if (clear) {
				e.value = 'Todos períodos';
			} else {
				if ($rootScope.dateMovements.length > 1) {
					$scope.filter.dataInicial = $rootScope.dateMovements[0];
					$scope.filter.dataFinal = $rootScope.dateMovements[1];

					if (!$scope.previousFilters) {
						$scope.previousFilters = {};
					}
					$scope.previousFilters.dataInicial = $scope.filter.dataInicial;
					$scope.previousFilters.dataFinal = $scope.filter.dataFinal;
				}
			}
		};

		$scope.changedPeriods = (value, clear) => {
			if (clear) {
				localStorage.setItem('__allowFilters__', true);

				$scope.clearData = true;

				$scope.filter.dataInicial = undefined;
				$scope.filter.dataFinal = undefined;

				if (!$scope.previousFilters) {
					$scope.previousFilters = {};
				}

				$scope.previousFilters.dataInicial = $scope.filter.dataInicial;
				$scope.previousFilters.dataFinal = $scope.filter.dataFinal;

				$rootScope.dateMovements = [];
				$rootScope.dateMovements[0] = $scope.filter.dataInicial;
				$rootScope.dateMovements[1] = $scope.filter.dataFinal;

				$rootScope.dataSelecionada = false;

				$scope.changeDataRange([]);
				$scope.allPeriods(clear);

				$scope.disableFilterMovementButton = false;
			}
		};

		$scope.changeDataRange = dateArr => {
			if (dateArr.length > 1) {
				$scope.filter.dataInicial = dateArr[0];
				$scope.filter.dataFinal = dateArr[1];
				$scope.changedPeriods(dateArr);
				$rootScope.dataSelecionada = true;
			} else if (dateArr.length == 1) {
				$scope.filter.dataInicial = dateArr[0];
				$scope.filter.dataFinal = dateArr[0];
				$scope.changedPeriods(dateArr);
			} else {
				dateArr = [];
				$scope.dateSource = {
					value: 'Todos períodos'
				};
				$rootScope.dateMovements = [];
				if ($scope.filter.dataInicial) delete $scope.filter.dataInicial;
				if ($scope.filter.dataFinal) delete $scope.filter.dataFinal;

				$rootScope.dataSelecionada = false;
			}
		};

		$rootScope.$$listeners['air-datepicker-range-change'] = [];
		$rootScope.$on('air-datepicker-range-change', (event, params) => {
			if (!$location.$$url.contains('/inss')) return;
			if (!params || !params.date) return;

			const len = params.date.length;

			if (len === 0) {
				$scope.dateSource = {
					value: 'Todos períodos'
				};
				$rootScope.dataSelecionada = false;
			} else if (len === 1) {
				if (!$rootScope.dataSelecionada) {
					const inicio = params.date[0];

					$scope.dateSource = {
						value: moment(inicio).format('DD/MM/YYYY')
					};
				}
			} else if (len === 2) {
				const inicio = params.date[0];
				const fim = params.date[1];

				const textoPeriodo =
					`${moment(inicio).format('DD/MM/YYYY')} até ` +
					`${moment(fim).format('DD/MM/YYYY')}`;

				$scope.dateSource = {
					value: textoPeriodo
				};

				$rootScope.dataSelecionada = true;
			}

			$scope.changeDataRange(params.date);

			if (len === 2) {
				$scope.allowFilterMovementButton(true);
			}
		});

		$rootScope.isAirDatepickerRangeOpen = false;

		$scope.onClickAirDatepickerRange = () => {
			if ($rootScope.isAirDatepickerRangeOpen) {
				$('#air-datepicker-range').trigger('blur');
			} else {
				$('#air-datepicker-range').trigger('focus');
			}
		};

		$scope.selectedFilter = () => {
			$scope.disableFilterProcessButton = false;
			$scope.disableFilterMovementButton = false;
		};

		$scope.updateBadges = () => {
			if ($scope.processFilter.inssDadoAcesso) {
				$scope.processBadges.inssDadoAcesso =
					$scope.processFilter.inssDadoAcesso;
			} else {
				$scope.processBadges.inssDadoAcesso = '';
			}
			if ($scope.processFilter.inssProcessos) {
				$scope.processBadges.inssProcessos =
					$scope.processFilter.inssProcessos.numeroProcesso;
			} else {
				$scope.processBadges.inssProcessos = '';
			}
			if ($scope.processFilter.inssSistema) {
				$scope.filtroSistemaLista.map(item => {
					if (item.idFonteXTipoPesquisa == $scope.processFilter.inssSistema) {
						$scope.processBadges.inssSistema = item.fontePesquisa;
					}
				});
			} else {
				$scope.processBadges.inssSistema = '';
			}
			if ($scope.processFilter.inssBuscaAndamento) {
				$scope.processBadges.inssBuscaAndamento =
					$scope.processFilter.inssBuscaAndamento == 'active_only'
						? 'Ativa'
						: $scope.processFilter.inssBuscaAndamento == 'inactive_only'
						? 'Inativa'
						: '';
			} else {
				$scope.processBadges.inssBuscaAndamento = '';
			}
		};

		$scope.updateBadges();

		$scope.clearFilter = (f, arr, clearAll = false) => {
			$scope.verifyPeriods(arr);

			if (clearAll) arr = types;

			arr.map(item => delete f[item]);

			if (JSON.stringify(f) === JSON.stringify({})) f = [];

			$scope.selectedFilter(f);

			if (clearAll) $scope.filterMovements($scope.filter, clearAll);
			if (!clearAll) filterSelect.removeOption(arr);
		};

		$scope.filterMovements = (filters, dateArr) => {
			if ($scope.isLoadingProcesses) {
				return;
			}

			$scope.isLoadingProcesses = true;

			let paginaAtual = 1;
			const urlParams = $location.$$url.split('?')[1];

			if (urlParams) {
				const pages = urlParams.split('&');

				pages.forEach(page => {
					const parameter = page.split('=');

					if (
						parameter[0] &&
						parameter[1] &&
						parameter[0] == 'numeroProcesso'
					) {
						$scope.numeroProcesso = parameter[1];
					}
				});
			}

			if (!$rootScope.dateMovements) {
				$rootScope.dateMovements = [];
			}

			const hasDateFromPicker = Array.isArray(dateArr) && dateArr.length === 2;

			if (hasDateFromPicker) {
				$rootScope.dateMovements[0] = dateArr[0];
				$rootScope.dateMovements[1] = dateArr[1];
			}

			const hasStoredRange =
				$rootScope.dateMovements[0] && $rootScope.dateMovements[1];

			if (hasStoredRange) {
				if (!filters.dataInicial)
					filters.dataInicial = $rootScope.dateMovements[0];
				if (!filters.dataFinal) filters.dataFinal = $rootScope.dateMovements[1];
			}

			$scope.filter.dataInicial = filters.dataInicial;
			$scope.filter.dataFinal = filters.dataFinal;

			//Se houver process Id na url
			const idClienteXFontePesqProc = $scope.processId;

			const paramsSearch = {
				idClienteXFontePesqProc,
				paginaAtual,
				registrosPorPagina: $scope.quantityPerPage,
				ordenacao: 'UltimoMovimento',
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			if (filters.lido) {
				paramsSearch.FlLido = filters.lido == 'lidos' ? true : false;
				$scope.movementsBadges.lido =
					filters.lido == 'lidos' ? 'Lidos' : 'Não Lidos';
			} else {
				$scope.movementsBadges.lido = '';
			}

			if (filters.dataInicial && filters.dataFinal) {
				paramsSearch.DataHoraAndProcessoInicio = filters.dataInicial;
				paramsSearch.DataHoraAndProcessoFim = filters.dataFinal;
				$scope.movementsBadges.dataInicial = filters.dataInicial;
				$scope.movementsBadges.dataFinal = filters.dataFinal;
			} else {
				$scope.movementsBadges.dataInicial = '';
				$scope.movementsBadges.dataFinal = '';
			}

			if (filters.andamento) {
				paramsSearch.IdTipoAndamentoProcesso = filters.andamento;
				$scope.filtroAndamentoLista.map(item => {
					if (item.id == filters.andamento) {
						$scope.movementsBadges.andamento = item.nome;
					}
				});
			} else {
				$scope.movementsBadges.andamento = '';
			}

			$http({
				...helper.http(API.sourceAccessData, 'movements'),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					$scope.movements = response.data.itens;
					$scope.processesList = response.data.itens;
					$scope.paginacao = response.data.paginacao;
					$scope.isMobile =
						window && window.innerWidth && window.innerWidth <= 991
							? true
							: false;

					$scope.disableFilterMovementButton = true;
				})
				.finally(() => {
					$scope.isLoadingProcesses = false;
				});

			$rootScope.newPublicationChecked = [];
			$('#movement-checkbox-all').prop('indeterminate', false);
			$('#movement-checkbox-all').prop('checked', false);
		};

		$scope.updateFilterSave = filters => {
			// Atualiza os filtros
			filters = {
				...filters,
				inssProcessosCompleto: $scope.processFilter.inssProcessos,
				inssBuscaAndamento: $scope.processFilter.inssBuscaAndamento
					? $scope.processFilter.inssBuscaAndamento
					: ''
			};

			// Salva de volta no sessionStorage
			sessionStorage.setItem(
				'_MODULE_MOVEMENTS_FILTERS_',
				JSON.stringify(filters)
			);
		};

		$scope.filterProcess = filters => {
			if ($scope.isLoadingProcesses) {
				return;
			}

			$scope.isLoadingProcesses = true;
			$scope.inssBuscaAndamento = false;
			$scope.registerAccess = false;

			let paginaAtual = 1;

			const paramsSearch = {
				paginaAtual,
				registrosPorPagina: $scope.quantityPerPage,
				ordenacao: 'UltimoMovimento',
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			if (filters.inssDadoAcesso)
				paramsSearch.DadoAcesso = filters.inssDadoAcesso;

			if (filters.inssProcessos) {
				paramsSearch.IdProcesso = filters.inssProcessos.idProcesso;
			}

			if (filters.inssSistema) {
				paramsSearch.IdFonteXTipoPesquisa = filters.inssSistema;
			}

			if (filters.inssBuscaAndamento) {
				paramsSearch.IdSitPesqProcUsuarioCliente =
					filters.inssBuscaAndamento == 'active_only' ? -1 : '-7,-9';
			}

			paramsSearch.ordenacao = '';

			for (let i = 1; i < 3; i++) {
				for (const [key] of Object.entries($scope.processOrderBy)) {
					if ($scope.processOrderBy[key] == i) {
						paramsSearch.ordenacao += paramsSearch.ordenacao == '' ? '' : ',';
						paramsSearch.ordenacao += key;
					}
					if ($scope.processOrderBy[key] == i * -1) {
						paramsSearch.ordenacao += paramsSearch.ordenacao == '' ? '' : ',';
						paramsSearch.ordenacao += '-' + key;
					}
				}
			}

			$scope.updateBadges();
			$scope.updateFilterSave(paramsSearch);

			$http({
				...helper.http(API.sourceAccessData, 'process'),
				method: 'GET',
				params: paramsSearch
			})
				.then(processData => {
					$scope.processesList = processData.data.itens;

					if (filters.inssBuscaAndamento) {
						$scope.inssBuscaAndamento =
							filters.inssBuscaAndamento !== 'active_only' &&
							$scope.processesList.length <= 0
								? true
								: false;
					}

					$scope.paginacao = processData.data.paginacao;

					$scope.isMobile =
						window && window.innerWidth && window.innerWidth <= 991
							? true
							: false;

					$scope.isLoadingAccessData = false;
				})
				.finally(() => {
					let oldFilters = { ...$scope.processFilter };

					$scope.processFilter = {
						inssDadoAcesso: paramsSearch.DadoAcesso,
						inssProcessos: {
							numeroProcesso: oldFilters.inssProcessos.numeroProcesso,
							idProcesso: paramsSearch.IdProcesso
						},
						inssSistema: paramsSearch.IdFonteXTipoPesquisa,
						inssBuscaAndamento:
							paramsSearch.IdSitPesqProcUsuarioCliente == -1
								? 'active_only'
								: paramsSearch.IdSitPesqProcUsuarioCliente == '-7,-9'
								? 'inactive_only'
								: ''
					};
					$scope.isLoadingProcesses = false;
				});

			$rootScope.newPublicationChecked = [];
			$('#movement-checkbox-all').prop('indeterminate', false);
			$('#movement-checkbox-all').prop('checked', false);
		};

		$scope.hasFilterNew = () => {
			/*
			No caso do previousFilters estar vazio, ele tentará pegar a
			informação do filter.dataInicial e filter.dataFinal, ou será
			definido como undefined
			*/
			if (!$scope.previousFilters) {
				if (Object.keys($scope.filter).length > 1) {
					$scope.previousFilters = {
						dataInicial: $scope.filter.dataInicial,
						dataFinal: $scope.filter.dataFinal
					};
				} else {
					$scope.previousFilters = {
						dataInicial: undefined,
						dataFinal: undefined
					};
				}
			}

			if (
				$rootScope.dateMovements &&
				$rootScope.dateMovements[0] &&
				$rootScope.dateMovements[1]
			) {
				$scope.filter.dataInicial = $rootScope.dateMovements[0];
				$scope.filter.dataFinal = $rootScope.dateMovements[1];
			}

			/*
			No caso da data do filtro ser alterada e ficar diferente da data anterior
			A data anterior deverá ser alterada e os filtros deverão ser habilitados novamente
			*/
			if (
				$scope.filter &&
				$scope.filter.dataInicial &&
				$scope.filter.dataFinal &&
				$scope.previousFilters &&
				!(
					$scope.filter.dataInicial === $scope.previousFilters.dataInicial &&
					$scope.filter.dataFinal === $scope.previousFilters.dataFinal
				)
			) {
				if (
					$scope.previousFilters.dataInicial &&
					$scope.previousFilters.dataInicial
				) {
					localStorage.setItem('__allowFilters__', true);
				}

				$scope.previousFilters.dataInicial = $scope.filter.dataInicial;
				$scope.previousFilters.dataFinal = $scope.filter.dataFinal;
			}

			let hasFilter = false;

			if (
				($scope.filter &&
					$scope.filter.dataInicial &&
					$scope.filter.dataFinal) ||
				($scope.filter && $scope.filter.lido) ||
				($scope.filter && $scope.filter.andamento)
			) {
				hasFilter = true;
			}

			return hasFilter;
		};

		$scope.verifyPeriods = arr => {
			if (
				(arr[0] == 'dataInicial' || arr.length == 0) &&
				$rootScope.pageSelected == 'Key'
			)
				$rootScope.periodsFolderType = true;
		};

		$scope.goBackMov = () => {
			$state.go(
				'root.default.movements.inss',
				{},
				{
					inherit: false,
					reload: 'root.default.movements.inss'
				}
			);
		};

		$scope.fetchCreditPlan = () => {
			$scope.creditPlanLoading = true;

			$http({
				...helper.http(API.userClientFunctionalities, 'GET'),
				params: {
					idFuncionalidade: -32
				}
			})
				.then(response => {
					$scope.creditPlan = response.data.itens[0];

					$scope.statusPlan = response.data.status.codigo;
				})
				.finally(() => {
					$scope.creditPlanLoading = false;
				});
		};

		$scope.fetchCreditPlan();

		$scope.getDisplayingRecordsValue = () => {
			return $scope.paginacao
				? $scope.paginacao.registrosTotal -
						$scope.paginacao.registrosPorPagina *
							($scope.paginacao.paginaAtual - 1) <
				  $scope.paginacao.registrosPorPagina
					? $scope.paginacao.registrosTotal -
					  $scope.paginacao.registrosPorPagina *
							($scope.paginacao.paginaAtual - 1)
					: $scope.paginacao.registrosPorPagina
				: 0;
		};

		$scope.hasMovementsPrevPage = () => {
			return $scope.paginacao.paginaAtual > 1 ? true : false;
		};

		$scope.hasMovementsNextPage = () => {
			return $scope.paginacao.paginaAtual < $scope.paginacao.paginaTotal
				? true
				: false;
		};

		$scope.changePage = direction => {
			let newPage = 1;

			switch (direction) {
				case 'first':
					newPage = 1;
					break;
				case 'prev':
					newPage = $scope.paginacao.paginaAtual - 1;
					break;
				case 'next':
					newPage = $scope.paginacao.paginaAtual + 1;
					break;
				case 'last':
					newPage = $scope.paginacao.paginaTotal;
					break;
			}

			let params = helper.cloneSimpleObject($stateParams);

			if (params && (params.processId || params.numeroProcesso)) {
				params.paginaAtual = newPage != 1 ? newPage : 1;

				let newParams = {};

				if (params.numeroProcesso)
					newParams.numeroProcesso = params.numeroProcesso;

				if (params.paginaAtual)
					newParams.paginaAtual = newPage != 1 ? newPage : 1;

				if (params.processId) newParams.processId = params.processId;

				if ($scope.filter.dataInicial) {
					newParams.dataInicial = $scope.filter.dataInicial;
				} else {
					newParams.dataInicial = null;
				}
				if ($scope.filter.dataFinal) {
					newParams.dataFinal = $scope.filter.dataFinal;
				} else {
					newParams.dataFinal = null;
				}
				if ($scope.filter.lido) {
					newParams.lido = $scope.filter.lido;
				} else {
					newParams.lido = null;
				}
				if ($scope.filter.andamento) {
					newParams.andamento = $scope.filter.andamento;
				} else {
					newParams.andamento = null;
				}

				let routeName = 'root.default.movements.inss';

				if ($state && $state.current && $state.current.name) {
					routeName = $state.current.name;
				}

				$state.go(routeName, newParams, {});
			} else {
				$scope.paginaAtual = newPage;

				$scope.fetchProcessAccessData();
			}
		};

		$scope.setMovementsAsRead = (newPublicationChecked, movement) => {
			let registros = [];

			if (!newPublicationChecked && !movement) {
				return;
			}

			if (newPublicationChecked) {
				newPublicationChecked.forEach(itemChecked => {
					registros.push(itemChecked.idMovProcUsuarioCliente.toString());
				});
			}
			if (movement) {
				registros.push(movement.idMovProcUsuarioCliente.toString());
			}

			$http({
				...helper.http(API.inssUpdateReadStatus, 'READ'),
				method: 'PUT',
				data: {
					idsMovProcUsuarioCliente: registros
				},
				messageOverride: {
					success(response, notify) {
						let message =
							registros.length > 1
								? 'As movimentações foram marcadas como lidas!'
								: 'A movimentação foi marcada como lida!';

						notify.success(message);
					}
				}
			}).then(() => {
				if (newPublicationChecked && $rootScope.newPublicationChecked) {
					$rootScope.newPublicationChecked.forEach(itemChecked => {
						itemChecked.lido = 1;
					});
				}

				if (movement) {
					movement.lido = 1;
				}
			});

			$scope.handleClick();
		};

		$scope.setMovementsAsUnread = (newPublicationChecked, movement) => {
			let registros = [];

			if (!newPublicationChecked && !movement) {
				return;
			}

			if (newPublicationChecked && newPublicationChecked.length > 0) {
				newPublicationChecked.forEach(itemChecked => {
					registros.push(itemChecked.idMovProcUsuarioCliente.toString());
				});
			}
			if (movement) {
				registros.push(movement.idMovProcUsuarioCliente.toString());
			}

			$http({
				...helper.http(API.inssUpdateReadStatus, 'UNREAD'),
				method: 'PUT',
				data: {
					idsMovProcUsuarioCliente: registros
				},
				messageOverride: {
					success(response, notify) {
						let message =
							registros.length > 1
								? 'As movimentações foram marcadas como não lidas!'
								: 'A movimentação foi marcada como não lida!';

						notify.success(message);
					}
				}
			}).then(() => {
				if (newPublicationChecked && $rootScope.newPublicationChecked) {
					$rootScope.newPublicationChecked.forEach(itemChecked => {
						itemChecked.lido = 0;
					});
				}

				if (movement) {
					movement.lido = 0;
				}
			});

			$scope.handleClick();
		};

		const queryConvert = () => {
			var queryStr = window.location.search,
				queryArr = queryStr.replace('?', '').split('&'),
				queryParams = [];

			for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
				var qArr = queryArr[q].split('='),
					obj = {
						key: qArr[0],
						value: qArr[1] ? qArr[1].replace(/%20/g, ' ') : qArr[1]
					};

				queryParams.push(obj);
			}

			return queryParams;
		};

		/** Altera a quantidade de registro po pagina na listagem */
		$scope.updateQuantityPerPage = quantityPerPage => {
			let filters = {};

			queryConvert().map(filter => (filters[filter.key] = filter.value));
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			let paramUsuarioProdAdv = 0;

			if (record && record.idParamUsuarioProdAdv) {
				paramUsuarioProdAdv = record.idParamUsuarioProdAdv;
			}

			$scope.idQtdItensPagina = $scope.idQtdItensPagina
				? $scope.idQtdItensPagina
				: paramUsuarioProdAdv;

			let method = $scope.idQtdItensPagina ? 'PUT' : 'POST';

			$scope.quantityPerPage = quantityPerPage;

			$http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [
						{
							id: record.idParamUsuarioProdAdv,
							qtdRegistroMovPorPagina: quantityPerPage || 20
						}
					]
				},
				messageOverride: {
					success() {},
					error() {}
				}
			}).then(() => {
				sessionStorage.setItem('__pageMovements__', 1);

				record.qtdRegistroMovPorPagina = quantityPerPage || 20;

				sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

				if (
					$location &&
					$location.search() &&
					$location.search().paginaAtual != 1
				) {
					$location.search({ paginaAtual: 1 });
				} else {
					$location.search({});
				}
			});
		};

		//fontes-pesquisa/lista-fonte-pesquisa-instituicao

		$scope.fetchSearchSources = () => {
			$http({
				...helper.http(API.searchFontsProcess, 'GET'),
				method: 'GET',
				params: {
					IdTipoPesquisa: -5
				}
			}).then(response => {
				const data = response && response.data ? response.data : null;
				const isSuccess =
					(data && data.codigo == 200) ||
					(data && data.status && data.status.codigo == 200);

				if (isSuccess && data && data.itens) {
					$scope.systemsDropdownItems = data.itens;
				}

				setTimeout(() => {
					$scope.isMobile =
						window && window.innerWidth && window.innerWidth <= 991
							? true
							: false;

					$scope.isLoadingAccessData = false;
					$scope.$apply();
				}, 500);
			});
		};

		$scope.ensureSearchSourcesLoaded = () => {
			if (!$scope.systemsDropdownItems || !$scope.systemsDropdownItems.length) {
				$scope.fetchSearchSources();
			}
		};

		$scope.getDetails = checkedPublications => {
			let params = {
				movements: '',
				readStatus: null
			};

			if ($scope.processId && $scope.processId.length > 0) {
				params.pasta = $scope.processId;
			}

			if (checkedPublications.length > 0) {
				$scope.readStatus = '';

				checkedPublications.forEach(item => {
					params.movements += item.idMovProcUsuarioCliente + ',';
					$scope.readStatus += item.lido + ',';
				});

				if ($scope.readStatus.includes('0')) {
					params.readStatus = true;
				}

				if ($scope.numeroProcesso) {
					params.numeroProcesso = $scope.numeroProcesso;
				}

				if ($scope.idProcesso) {
					params.idProcesso = $scope.idProcesso;
				}

				if ($scope.pastaProcesso) {
					params.pastaProcesso = $scope.pastaProcesso;
				}

				params.movements = params.movements.substring(
					0,
					params.movements.length - 1
				);

				$state.go('root.default.movements.inssDetails', params, {
					inherit: false,
					reload: 'root.default.movements.inssDetails'
				});
			}
		};

		$scope.selectPublication = (item, param) => {
			$rootScope.newPublicationChecked = $rootScope.newPublicationChecked
				? $rootScope.newPublicationChecked
				: [];
			if (item.__checked__ === true) {
				$rootScope.newPublicationChecked.push(item);
			} else if (param) {
				$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
					value => item.idProcesso !== value.idProcesso
				);
			} else {
				$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
					value => item.idMovProcessoCliente !== value.idMovProcessoCliente
				);
			}

			let hasTrue = false;
			let hasFalse = false;

			const idClienteXFontePesqProc = $scope.processId;

			if (idClienteXFontePesqProc) {
				hasTrue = $scope.movements.some(item => item.__checked__);
				hasFalse = $scope.movements.some(item => !item.__checked__);
			} else {
				hasTrue = $scope.processesList.some(item => item.__checked__);
				hasFalse = $scope.processesList.some(item => !item.__checked__);
			}

			if (hasTrue) {
				if (hasFalse) {
					$('#movement-checkbox-all').prop('indeterminate', true);
					$('#movement-checkbox-all').prop('checked', false);
					$scope.allSelected = false;
				} else {
					$('#movement-checkbox-all').prop('indeterminate', false);
					$('#movement-checkbox-all').prop('checked', true);
					$scope.allSelected = true;
				}
			} else if (hasFalse) {
				$('#movement-checkbox-all').prop('indeterminate', false);
				$('#movement-checkbox-all').prop('checked', false);
			}

			const checked = $rootScope.newPublicationChecked;

			if (!checked || checked.length < 2) $scope.itemCheckedDisable = true;
			else $scope.itemCheckedDisable = false;

			if ($rootScope.newPublicationChecked.length >= 2) {
				var sitProcInssInativo = [];

				for (
					let index = 0;
					index < $rootScope.newPublicationChecked.length;
					index++
				) {
					if (
						$rootScope.newPublicationChecked[index].sitPesqProcUsuarioCliente !=
						'Ativo'
					) {
						sitProcInssInativo.push(
							$rootScope.newPublicationChecked[index].idFontePesqProcesso
						);
					}
				}
				if (
					sitProcInssInativo.length === $rootScope.newPublicationChecked.length
				) {
					$scope.enableSensorsInssAll = true;
					$scope.disabledSensorsInssAll = false;
				} else {
					$scope.enableSensorsInssAll = false;
					$scope.disabledSensorsInssAll = true;
				}
			} else {
				$scope.enableSensorsInssAll = false;
				$scope.disabledSensorsInssAll = false;
			}
		};

		$scope.selectAllPublications = (movements, processesList) => {
			$scope.clearAll = false;
			$rootScope.newPublicationChecked = [];

			const idClienteXFontePesqProc = $scope.processId;

			const itemsToUpdate = idClienteXFontePesqProc ? movements : processesList;

			if (movements.length == 0 && processesList.length == 0) {
				return;
			}

			if (
				$('#movement-checkbox-all').prop('indeterminate') ||
				$('#movement-checkbox-all').prop('checked')
			) {
				itemsToUpdate.forEach(item => {
					item.__checked__ = true;
					$rootScope.newPublicationChecked.push(item);
				});

				$('#movement-checkbox-all').prop('indeterminate', false);
				$('#movement-checkbox-all').prop('checked', true);
			} else {
				itemsToUpdate.forEach(item => {
					item.__checked__ = false;
					$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
						value => item.idMovProcessoCliente !== value.idMovProcessoCliente
					);
				});
				$('#movement-checkbox-all').prop('indeterminate', false);
				$('#movement-checkbox-all').prop('checked', false);
			}

			const checked = $rootScope.newPublicationChecked;

			if (!checked || checked.length < 2) $scope.itemCheckedDisable = true;
			else $scope.itemCheckedDisable = false;

			if ($rootScope.newPublicationChecked.length > 0) {
				var sitProcInssInativo = [];

				for (
					let index = 0;
					index < $rootScope.newPublicationChecked.length;
					index++
				) {
					if (
						$rootScope.newPublicationChecked[index].sitPesqProcUsuarioCliente !=
						'Ativo'
					) {
						sitProcInssInativo.push(
							$rootScope.newPublicationChecked[index].idFontePesqProcesso
						);
					}
				}
				if (
					sitProcInssInativo.length === $rootScope.newPublicationChecked.length
				) {
					$scope.enableSensorsInssAll = true;
					$scope.disabledSensorsInssAll = false;
				} else {
					$scope.enableSensorsInssAll = false;
					$scope.disabledSensorsInssAll = true;
				}
			} else {
				$scope.enableSensorsInssAll = false;
				$scope.disabledSensorsInssAll = false;
			}
		};

		$scope.toggleAllMovements = toggle => {
			$scope.clearAll = !toggle;
			$scope.itemChecked = !toggle;

			if ($scope.clearAll === false) {
				$rootScope.newPublicationChecked = [];
				$('#movement-checkbox-all').prop('indeterminate', false);
				$('#movement-checkbox-all').prop('checked', false);

				$scope.movements.forEach(item => {
					item.__checked__ = false;
					$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
						value => item.idMovProcessoCliente !== value.idMovProcessoCliente
					);
				});
			}

			if (toggle) $scope.itemCheckedDisable = true;

			$scope.blockDownload = false;
		};

		$scope.changeInssProcessSituation = (items, situation) => {
			$scope.disabledSensorsInss = true;

			var procsIds = [];

			if (items.length > 1) {
				for (let index = 0; index < items.length; index++) {
					procsIds.push(items[index].idFontePesqProcesso);
				}
			} else {
				procsIds[0] = items.idFontePesqProcesso;
			}

			if (situation) {
				var newSituation = situation;
			} else {
				if (items.sitPesqProcUsuarioCliente == 'Ativo') {
					var newSituation = -7;
				} else {
					var newSituation = -1;
				}
			}

			if (newSituation == -1 && $scope.creditPlan.qtdDisponivel == 0) {
				notification.danger('Não há créditos suficientes para ativar.');
				$scope.disabledSensorsInss = false;

				return;
			}

			$http({
				...helper.http(API.userCustomerAutomaticSearch, 'PUT'),
				data: {
					itens: [
						{
							idSituacaoPesquisaProcesso: newSituation,
							idsFontesPesquisaProcesso: procsIds,
							idGrupoUsuarios:
								$scope.groupUserSelected && $scope.groupData
									? $scope.groupData.idGrupo
									: null
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						if (newSituation == -1) {
							notify.success('Sucesso ao ativar busca automática de processos');
						} else {
							notify.success(
								'Sucesso ao inativar busca automática de processos'
							);
						}

						$scope.itemCheckedDisable = true;
					},
					error(response, notify) {
						if (newSituation == -1) {
							notify.danger('Erro ao ativar busca automática de processos');
						} else {
							notify.danger('Erro ao inativar busca automática de processos');
						}
					}
				}
			})
				.then(() => {
					if (situation) {
						if (procsIds.length === $scope.processesList.length) {
							for (
								let index = 0;
								index < $scope.processesList.length;
								index++
							) {
								if (newSituation === '-7,-9') {
									$scope.processesList[index].sitPesqProcUsuarioCliente =
										'Inativo - solicitado pelo cliente';
								} else {
									$scope.processesList[index].sitPesqProcUsuarioCliente =
										'Ativo';
								}
							}
						} else {
							for (let index1 = 0; index1 < procsIds.length; index1++) {
								for (
									let index2 = 0;
									index2 < $scope.processesList.length;
									index2++
								) {
									if (
										$scope.processesList[index2].idFontePesqProcesso ===
										procsIds[index1]
									) {
										if (newSituation === '-7,-9') {
											$scope.processesList[index2].sitPesqProcUsuarioCliente =
												'Inativo - solicitado pelo cliente';
										} else {
											$scope.processesList[index2].sitPesqProcUsuarioCliente =
												'Ativo';
										}
									}
								}
							}
						}
					} else {
						for (let index1 = 0; index1 < procsIds.length; index1++) {
							for (
								let index2 = 0;
								index2 < $scope.processesList.length;
								index2++
							) {
								if (
									$scope.processesList[index2].idFontePesqProcesso ===
									procsIds[index1]
								) {
									if (
										$scope.processesList[index2].sitPesqProcUsuarioCliente ===
										'Ativo'
									) {
										$scope.processesList[index2].sitPesqProcUsuarioCliente =
											'Inativo - solicitado pelo cliente';
									} else {
										$scope.processesList[index2].sitPesqProcUsuarioCliente =
											'Ativo';
									}
								}
							}
						}
					}

					var sitProcInssInativo = [];

					if (!situation || procsIds.length === $scope.processesList.length) {
						for (let index = 0; index < $scope.processesList.length; index++) {
							if (
								$scope.processesList[index].sitPesqProcUsuarioCliente != 'Ativo'
							) {
								sitProcInssInativo.push(
									$scope.processesList[index].idFontePesqProcesso
								);
							}
						}
						if (sitProcInssInativo.length === $scope.processesList.length) {
							$scope.enableSensorsInssAll = true;
							$scope.disabledSensorsInssAll = false;
						} else {
							$scope.enableSensorsInssAll = false;
							$scope.disabledSensorsInssAll = true;
						}
					} else {
						for (let index1 = 0; index1 < procsIds.length; index1++) {
							for (
								let index2 = 0;
								index2 < $scope.processesList.length;
								index2++
							) {
								if (
									$scope.processesList[index2].idFontePesqProcesso ===
									procsIds[index1]
								) {
									if (
										$scope.processesList[index2].sitPesqProcUsuarioCliente !=
										'Ativo'
									) {
										sitProcInssInativo.push(
											$scope.processesList[index2].idFontePesqProcesso
										);
									}
								}
							}
						}
						if (sitProcInssInativo.length === procsIds.length) {
							$scope.enableSensorsInssAll = true;
							$scope.disabledSensorsInssAll = false;
						} else {
							$scope.enableSensorsInssAll = false;
							$scope.disabledSensorsInssAll = true;
						}
					}

					$scope.fetchCreditPlan();

					$scope.filterProcess($scope.processFilter);

					setTimeout(() => {
						$scope.disabledSensorsInss = false;
					}, 1);
				})
				.finally(() => {
					setTimeout(() => {
						$scope.disabledSensorsInss = false;
					}, 200);
				});
		};

		$scope.openModalDownloadMovements = file => {
			if ($scope.clearAll) {
				$('#modalDownload').modal('hide');
				$('#modalAllDownloads').modal('show');
				$scope.saveFileType = file;

				$timeout(function() {
					document.getElementById('inputCreateEmail').focus();
				}, 600);
			} else {
				$scope.downloadMovements(file);
			}
		};

		$scope.downloadMovements = (fileType = 'pdf', selectAll = false) => {
			$('#modalDownload').modal('hide');
			$scope.blockDownload = true;

			if ($scope.clearAll) {
				let paramsSearch = {
					tipoArquivo: fileType,
					IdPastaUsuarioCliente: $scope.pastaProcesso
				};

				if (selectAll) {
					paramsSearch.marcarNaoLidos = true;
				} else {
					paramsSearch.marcarNaoLidos = false;
				}

				let emails = '';

				if (typeof $scope.saveEmail.email == 'string') {
					let emailsSplitted = $scope.saveEmail.email.split(';');
					const uniqueItems = [];
					var newEmailString = '';
					let error = '';

					emailsSplitted.forEach(email => {
						if (!uniqueItems.includes(email.trim())) {
							uniqueItems.push(email.trim());
							if (newEmailString != '') {
								newEmailString += ';';
							}
							newEmailString += email.trim();
						} else {
							$('#inputCreateEmail').removeClass('is-valid');
							$('#inputCreateEmail').removeClass('is-invalid');

							error = 'Mesmo endereço de email utilizado!';
						}
					});

					if (error != '') {
						return notification.danger(error);
					}

					emails = newEmailString;
				} else {
					$scope.saveEmail.email.forEach(email => {
						if (emails == '') {
							emails += email;
						} else {
							emails += ';' + email;
						}
					});
				}

				if ($scope.filter.lido) {
					paramsSearch.lido = $scope.filter.lido;
				}

				if ($scope.filter.dataInicial && $scope.filter.dataFinal) {
					paramsSearch.dataMovimentoInicio = $scope.filter.dataInicial;
					paramsSearch.dataMovimentoFim = $scope.filter.dataFinal;
				}

				if ($scope.filter.andamento) {
					paramsSearch.idTipoMovProcesso = $scope.filter.andamento;
				}

				paramsSearch.emails = emails;

				$scope.openDownloadMovements = true;

				$http({
					...helper.http(API.downloads, 'all'),
					method: 'POST',
					data: { itens: [{ ...paramsSearch }] },
					messageOverride: {
						success(response, notify) {
							notify.success(response.data.status.mensagem);
						},
						error(response, notify) {
							notify.danger(response.data.status.mensagem);
						}
					},
					noCancelOnRouteChange: true
				}).finally(() => {
					$scope.toggleAllMovements(true);
					$('#modalToggleAsReadAll').modal('hide');
					$scope.openDownloadMovements = false;
					$scope.saveEmail = [];
					$scope.emptyEmail = {
						email: ''
					};
					$('#inputCreateEmail').removeClass('is-valid');
					$('#inputCreateEmail').removeClass('is-invalid');
				});

				return;
			}

			const movement = $scope.movementInAction;
			const checkedItems = $rootScope.newPublicationChecked;

			if (!movement && !checkedItems.length)
				return notification.danger('Nenhum movimento selecionado.');

			let ids = movement.length
				? checkedItems.map(x => x.idMovProcessoCliente).join()
				: movement.idMovProcessoCliente;

			notification.success('Download iniciado! Isso pode levar algum tempo.');

			setTimeout(() => {
				const hasUnread = movement.length
					? checkedItems.some(item => !item.lido)
					: !movement.lido;

				if (hasUnread) $('#modalToggleAsRead').modal('show');
			}, 200);

			const params = {
				ids,
				tipoArquivo: fileType,
				idGrupoMovimento:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			const api = 'movements';

			downloadService.serviceDownload(params, api);
			$scope.blockDownload = false;
		};

		$scope.openModalMarcarComoLidoAll = emails => {
			var newEmailString = '';
			const uniqueItems = [];
			let error = '';

			if (typeof emails == 'string') {
				let emailsSplitted = emails.split(';');

				emailsSplitted.forEach(email => {
					if (!uniqueItems.includes(email)) {
						uniqueItems.push(email);
						if (newEmailString != '') {
							newEmailString += ';';
						}
						newEmailString += email;
					} else {
						error = 'Mesmo endereço de email utilizado!';
					}
				});
			} else {
				emails.forEach(email => {
					if (!uniqueItems.includes(email.trim())) {
						uniqueItems.push(email.trim());
						if (newEmailString != '') {
							newEmailString += ';';
						}
						newEmailString += email.trim();
					} else {
						$('#inputCreateEmail').removeClass('is-valid');
						$('#inputCreateEmail').removeClass('is-invalid');
						error = 'Mesmo endereço de email utilizado!';
					}
				});
			}

			if (error != '') {
				return notification.danger(error);
			}

			emails = newEmailString;

			if ($scope.filter.lido == 'true') {
				$('#modalAllDownloads').modal('hide');
				$scope.downloadMovements($scope.saveFileType, false);
			} else {
				$('#modalAllDownloads').modal('hide');
				$('#modalToggleAsReadAll').modal('show');
			}
		};

		$scope.printMovements = movement => {
			//$scope.closeAllMovements();

			$scope.printing = true;
			$scope.loadingPrint = true;

			$scope.movementInAction = movement
				? movement
				: $rootScope.newPublicationChecked;

			if (!movement) {
				var checkedItems = $rootScope.newPublicationChecked;

				if (!movement && !checkedItems.length)
					return notification.danger('Nenhum movimento selecionado.');

				var ids = checkedItems.length
					? checkedItems.map(x => x.idMovProcessoCliente).join()
					: movement.idMovProcessoCliente.toString();
			}

			$http({
				...helper.http(API.downloads, 'movements'),
				params: {
					ids: ids ? ids : movement.idMovProcessoCliente,
					tipoArquivo: 'pdf',
					quebrarPaginaImpressao: false,
					idGrupoMovimento:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				},
				responseType: 'blob',
				noCancelOnRouteChange: true
			})
				.then(async response => {
					const { data, status } = response;

					const prevIframes = document.querySelectorAll(
						'.__printable-pdf-frame'
					);

					if (prevIframes.length)
						prevIframes.forEach(iframe => iframe.remove());

					if (status > 299)
						return notification.danger('Erro ao imprimir movimentações.');

					const file = new Blob([data], { type: 'application/pdf' });

					await file.dataURL().then(() => {
						if (navigator.userAgent.indexOf('Chrome') !== -1) {
							const iframe = document.createElement('iframe');

							iframe.className = '__printable-pdf-frame';

							iframe.style.position = 'fixed';
							iframe.style.bottom = '-100vh';

							iframe.src = URL.createObjectURL(file);

							document.body.appendChild(iframe);

							iframe.contentWindow.focus();

							setTimeout(() => {
								iframe.contentWindow.print();
							}, 1);
						}
						const isIe = /*@cc_on!@*/ false || !!document.documentMode;

						if (isIe)
							window.navigator.msSaveOrOpenBlob(
								file,
								'msSaveBlob_testFile.pdf'
							);

						if (navigator.userAgent.indexOf('Firefox') !== -1) {
							let newWindow = window.open(
								URL.createObjectURL(file),
								'name',
								'height=800,width=1000'
							);

							newWindow.focus();

							setTimeout(() => newWindow.print(), 1000);
						}

						$timeout(() => {
							$scope.loadingPrint = false;
						}, 1000);
					});
				})
				.finally(() => {
					const hasUnread = movement
						? !movement.lido
						: checkedItems.some(item => !item.lido);

					if (hasUnread) {
						$timeout(() => $('#modalToggleAsRead').modal('show'), 1500);
						if (movement == undefined) $scope.itemCheckedDisable = false;
					}

					$timeout(() => {
						$scope.loadingPrint = false;
					}, 1000);
				});
		};

		$scope.listAddEmail = emails => {
			if (emails) {
				emails = emails.split(';');

				emails.forEach(email => {
					$scope.publishEmail.push({ email: email });
				});
			}

			$scope.formatEmail($scope.publishEmail);
		};

		$scope.formatEmail = emails => {
			var email = [];

			emails.forEach(value => email.push(value.email));

			if (emails.length > 1) email = email.join(';');
			$scope.saveEmail.email = email;
			$scope.publishEmail = [];
		};

		$scope.changeProcessFilter = filters => {
			setTimeout(() => {
				filters.inssDadoAcesso = $('#btnFilterByAccessData').attr(
					'ng-custom-model'
				);

				$scope.processFilter = filters;
				$scope.selectedFilter();
				$scope.$apply();
			}, 100);
		};

		$scope.changeProcessNumberFilter = filters => {
			setTimeout(() => {
				filters.inssProcessos.numeroProcesso = $(
					'#btnFilterByProcessNumber'
				).attr('ng-custom-model');
				filters.inssProcessos.idProcesso = $('#btnFilterByProcessNumber').attr(
					'ng-process-value'
				);

				$scope.processFilter = filters;
				$scope.selectedFilter();
				$scope.$apply();
			}, 100);
		};

		/** Método prepara movimentos para marcar como LIDAS as movimentações,
		 * quando e feita alguma ação quando ela esta não lida
		 * exemplo: (Enviar por email, Download etc)
		 */
		$scope.markAsReadAfterAction = () => {
			$timeout(() => {
				const movement = $scope.movementInAction;

				if (movement.length) {
					$scope.setMovementsAsRead($rootScope.newPublicationChecked, false);
				} else {
					$scope.setMovementsAsRead(false, movement);
				}

				if ($rootScope.newPublicationChecked) {
					const checked = helper.cloneSimpleObject(
						$rootScope.newPublicationChecked
					);

					if (checked && checked.length > 1) {
						$scope.itemCheckedDisable = false;
					} else {
						$scope.itemCheckedDisable = true;
					}
				}
			}, 500);
		};

		/** Método que fecha o modal quando usuário decide manter as
		 * movimentações como NÃO LIDAS
		 */
		$scope.declineMarkAsRead = () => {
			$scope.itemCheckedDisable = true;
			$scope.movementInAction = null;

			$timeout(() => {
				$scope.printing = false;
			}, 300);

			$('#modalToggleAsRead').modal('hide');

			const checked = helper.cloneSimpleObject(
				$rootScope.newPublicationChecked ? $rootScope.newPublicationChecked : []
			);

			if (checked && checked.length >= 2) {
				$scope.itemCheckedDisable = false;
			} else {
				$scope.itemCheckedDisable = true;
			}
		};

		$scope.deleteProcessINSS = params => {
			var paramsProcessHeader = {
				idsClienteXFontePesqProc: [],
				idsPesqProcUsuarioCliente: []
			};

			if (params.length > 1) {
				for (let index = 0; index < params.length; index++) {
					paramsProcessHeader.idsClienteXFontePesqProc.push(
						params[index].idClienteXFontePesqProc
					);
					paramsProcessHeader.idsPesqProcUsuarioCliente.push(
						params[index].idPesqProcUsuarioCliente
					);
				}
			} else {
				if (!!params && params.idClienteXFontePesqProc) params = [params];

				paramsProcessHeader.idsClienteXFontePesqProc.push(
					params[0].idClienteXFontePesqProc
				);
				paramsProcessHeader.idsPesqProcUsuarioCliente.push(
					params[0].idPesqProcUsuarioCliente
				);
			}

			$http({
				...helper.http(API.deleteProcessINSS, 'PUT'),
				data: {
					idUsuarioCliente: params[0].idUsuarioCliente,
					idsClienteXFontePesqProc:
						paramsProcessHeader.idsClienteXFontePesqProc,
					idsPesqProcUsuarioCliente:
						paramsProcessHeader.idsPesqProcUsuarioCliente,
					idGrupoUsuarios:
						params[0].idGrupoUsuarios ||
						($scope.groupUserSelected && $scope.groupData)
							? $scope.groupData.idGrupo
							: null,
					excluirPrazosVinculados:
						$scope.deleteProcessOptions.deleteLinkedDeadlines === 2
							? true
							: false
				},
				messageOverride: {
					success(response, notify) {
						notify.success(response.data.status.mensagem);
						$scope.closeModal('#modalDeleteProcessMain');
					},
					error(response, notify) {
						notify.danger(response.data.status.erros[0].mensagem);
						$scope.closeModal('#modalDeleteProcessMain');
					}
				}
			})
				.then(response => {
					const data = response.data;

					if (data && data.status.codigo == 200) {
						data.itens.forEach(item => {
							item.fontesProcesso.forEach(fonte => {
								fonte.mostrarFonte = false;
							});
						});
					}
				})
				.finally(() => {
					$rootScope.newPublicationChecked = [];
					$('#movement-checkbox-all').prop('indeterminate', false);
					$('#movement-checkbox-all').prop('checked', false);

					$scope.itemCheckedDisable = true;

					if ($scope.processId) {
						$state.go(
							'root.default.movements.inss',
							{},
							{
								inherit: false,
								reload: true
							}
						);
					} else {
						if (
							$scope.processesList &&
							$scope.processesList.length > 0 &&
							paramsProcessHeader.idsClienteXFontePesqProc
						) {
							$scope.processesList = $scope.processesList.filter(item => {
								return (
									item.idClienteXFontePesqProc !==
									paramsProcessHeader.idsClienteXFontePesqProc
								);
							});

							$scope.closeModal('#modalDeleteProcessMain');
							$scope.fetchProcessAccessData();
						}
					}
				});
		};

		$scope.deleteProcess = process => {
			let idsFontesProcesso = [];
			let idSituacaoPesquisaProcesso = -8;

			const paramsProcessHeader = {
				IdClienteXFontePesqProc: process[0].idClienteXFontePesqProc,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			let fontesProcesso = null;

			$http({
				...helper.http(API.inssProcessHeader, 'detail'),
				method: 'GET',
				params: paramsProcessHeader
			})
				.then(response => {
					const data = response.data;

					if (data && data.status.codigo == 200) {
						data.itens.forEach(item => {
							item.fontesProcesso.forEach(fonte => {
								fonte.mostrarFonte = false;
							});
						});

						fontesProcesso = data.itens[0].fontesProcesso;
					}
				})
				.finally(() => {
					if (fontesProcesso && fontesProcesso != null) {
						fontesProcesso.forEach(source => {
							idsFontesProcesso.push(source.idFonteProcesso);
						});

						$http({
							...helper.http(API.inssProcessHeader, 'updateAutomaticSource'),
							method: 'PUT',
							data: {
								itens: [
									{
										idsFontesProcesso,
										idSituacaoPesquisaProcesso,
										idGrupoUsuarios:
											$scope.groupUserSelected && $scope.groupData
												? $scope.groupData.idGrupo
												: null
									}
								]
							}
						})
							.then(response => {
								const { data } = response;

								if (data.status && data.status.codigo == 200) {
									process.idSitPesqProcUsuarioCliente = idSituacaoPesquisaProcesso;
								}
							})
							.finally(() => {
								if ($scope.processId) {
									$state.go(
										'root.default.movements.inss',
										{},
										{
											inherit: false,
											reload: true
										}
									);
								} else {
									if (
										$scope.processesList &&
										$scope.processesList.length > 0 &&
										paramsProcessHeader.IdClienteXFontePesqProc
									) {
										$scope.processesList = $scope.processesList.filter(item => {
											return (
												item.idClienteXFontePesqProc !==
												paramsProcessHeader.IdClienteXFontePesqProc
											);
										});

										$scope.closeModal('#modalDeleteProcess');
										$scope.fetchProcessAccessData();
									}
								}
							});
					}
				});
		};

		$scope.changeOrder = order => {
			if ($scope.isLoadingProcesses) {
				return;
			}

			if (
				$scope.processOrderBy[order] == 1 ||
				$scope.processOrderBy[order] == -1
			) {
				$scope.processOrderBy[order] *= -1;
			} else {
				for (const [key] of Object.entries($scope.processOrderBy)) {
					if (key == order) {
						if ($scope.processOrderBy[key] > 0) {
							$scope.processOrderBy[key] = 1;
						} else {
							$scope.processOrderBy[key] = -1;
						}
					} else {
						if ($scope.processOrderBy[key] > 0) {
							$scope.processOrderBy[key] += 1;
						} else {
							$scope.processOrderBy[key] += -1;
						}
					}
				}
			}

			$scope.filterProcess($scope.processFilter);
		};

		$scope.actions = (process, i) => {
			$scope.handleClick();

			let element = document.getElementById(`dropdown-inss-${i}`);

			if (element && element.className) element.className += ' opened';
		};

		$scope.actionsMobile = () => {
			$scope.handleClick();

			let element = document.getElementById('dropdown-inss-mobile-all');

			if (element && element.className) element.className += ' opened';
		};

		$scope.handleClick = () => {
			const allElements = document.querySelectorAll('.opened');

			for (const element of allElements) {
				element.classList.remove('opened');
			}
		};

		$scope.customSearch = text => {
			if (text && typeof text == 'string')
				return text.replace(/[.,\/\-_]/g, '');
		};

		$scope.allowFilterMovementButton = status => {
			$scope.disableFilterMovementButton = !status;
		};

		$scope.returnToPreviousPage = () => {
			$state.transitionTo('root.default.initial', {
				inherit: false,
				reload: true
			});
		};

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});

		$scope.changeCheckboxDontShowAgain = () => {
			$scope.dontShowAgainCheckbox = !$scope.dontShowAgainCheckbox;
		};

		$scope.closeSuccessModal = () => {
			if ($scope.dontShowAgainCheckbox) {
				localStorage.setItem('__dontShowSuccessRegisterModalAgain__', true);
			} else {
				localStorage.setItem('__dontShowSuccessRegisterModalAgain__', false);
			}

			$scope.closeModal('#modalRegisterINSSAccount');
		};

		/** Permissão Criar Prazo */
		$scope.permissionsUserClient = () => {
			$http({
				...helper.http(API.permissions, 'GET'),
				params: {
					...helper.httpFields([
						'idFuncionalidade',
						'idUsuarioClienteXFuncionalidade'
					]),
					registrosPorPagina: -1,
					ativo: true
				}
			}).then(response => {
				for (let index = 0; index < response.data.itens.length; index++) {
					if (response.data.itens[index].idFuncionalidade == -23) {
						$scope.permissionGoogleCalendar = true;
					}
				}
			});
		};

		/** Método que fica observando se modal de prazos foi fechado
		 *  para resetar form do modal
		 */
		$('#modalCreateAgendaEventComponent').on('hide', () => {
			$rootScope.formCreatePrazo.taskToEdit.processo = {};

			return $scope.$resetFormValidation('createEvent')();
		});

		/** Método para trazer os registros da agenda */
		$scope.recordAgendas = responseStore => {
			const idUsuarioCliente =
				parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
				undefined;

			$http({
				...helper.http(API.agendas, 'GET'),
				params: {
					...helper.httpFields(['id']),
					idUsuarioCliente: idUsuarioCliente
				}
			}).then(response => responseStore.setItems(response.data.itens));
		};

		$scope.checkShouldDeleteDeadlineOption = newValue => {
			$scope.shouldDeleteDeadlineOption = newValue;
		};

		/** Método para verificar os tipos de eventos na agenda */
		$scope.recordEventsTypes = responseStore => {
			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			$http({
				...helper.http(API.eventsTypes, 'GET'),
				params: {
					...helper.httpFields(['id,nome']),
					idCliente,
					ativo: true
				}
			}).then(({ data }) => {
				responseStore.setItems(data.itens);

				// Converte o array para uma string e armazena no Session Storage
				sessionStorage.setItem(
					'__EVENTS_TYPES__',
					JSON.stringify(responseStore.getItems())
				);

				$rootScope.formCreatePrazo.eventsTypes = responseStore;

				$scope.selectedType = data.itens.find(item => item.nome == 'Prazo');
			});
		};

		// /** Verifica as permições do usuário */
		// permissions
		// 	.loadPermissions()
		// 	.then(async () => {
		// 		if (blocked !== 'true') {
		// 			/** Ações no carregamento da pág */
		// 			!$scope.palavraChaveSelecionada.length && $scope.keywordsAll();
		// 			!$scope.keyWordAccount && $scope.keywordPubliGeneral();
		// 			!$scope.diaryAccount && $scope.diaryGeneral();

		// 			if (!location.pathname.includes('detalhes')) {
		// 				$scope.publicationPermission = permissions.has(
		// 					'recordPublications'
		// 				);

		// 				$scope.movementPermission = permissions.has('createMovements');

		// 				$scope.showVideo =
		// 					!$scope.publicationPermission && !$scope.movementPermission;

		// 				$scope.allOfAccount = !!!$stateParams.pasta;

		// 				if ($scope.publicationPermission || $scope.movementPermission) {
		// 					await $scope.recordParametersUsers();
		// 					$scope.recordBriefcase($scope.briefcase);
		// 				}
		// 			}
		// 		}
		// 	})
		// 	.finally(() => {
		// 		$scope.loadingPage = false;
		// 		$scope.loadingSide = false;
		// 	});

		/** Integração com a agenda */
		$scope.agendaEventDefault = {
			title: '',
			address: '',
			initialHour: '',
			wholeDay: false,
			eventTypeId: '',
			initialDate: '',
			observation: '',
			reminderTypeId: '',
			finalRecurrenceDate: '',
			recurringEventTypeId: ''
		};

		$scope.agendaEvent = helper.cloneSimpleObject($scope.agendaEventDefault);

		$rootScope.formCreatePrazo.getEventComponent = () => {
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		};

		/** prepara registro para criação de vento evento vinculando
		 * movimento na agenda
		 */
		$scope.createAgendaEvent = async form => {
			$rootScope.creationEventLoading = true;

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			$scope.googleSync = dataSync.sincronizado;

			const fields = [
				'titulo',
				'dataHora',
				'dataHoraInicio',
				'diaInteiro',
				'idLembrete',
				'idOpcaoLembreteAgenda',
				'idRepetEventoAgenda',
				'localizacao',
				// 'observacao',
				'idTipoEventoAgenda',
				'idMovProcessoCliente',
				'sincronizado'
			];

			let [
				titulo,
				dataHora = `${new Date().getHours()}:30`,
				dataHoraInicio = new Date().toLocaleDateString('pt-BR'),
				diaInteiro,
				idOpcaoLembreteAgenda = $rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.idNotificacaoCompromisso
					? $rootScope.formCreatePrazo.idNotificacaoCompromisso
					: -1,
				idRepetEventoAgenda = -1,
				localizacao,
				idProcesso,
				// observacao,
				idTipoEventoAgenda,
				idMovProcessoCliente,
				sincronizado
			] = fields.map(input => $scope.getScopedInputValue(form[input]));

			if (form['localizacao']) {
				localizacao = $scope.getScopedInputValue(form['localizacao']);
			}

			if (
				$rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.taskToEdit &&
				$rootScope.formCreatePrazo.taskToEdit.processo
			) {
				idProcesso = $rootScope.formCreatePrazo.taskToEdit.processo.id || null;
			}

			const endHour = $scope.getScopedInputValue(form.dataHoraFim);

			let importante, remoto, presencial;

			if (form && form['importante']) {
				importante =
					form['importante'].$viewValue || form['importante'].$modelValue;
			}

			if (form && form['presencial']) {
				presencial =
					form['presencial'].$viewValue || form['presencial'].$modelValue;
			}

			if (form && form['remoto']) {
				remoto = form['remoto'].$viewValue || form['remoto'].$modelValue;
			}

			const eventDate = `${dataHoraInicio.substr(3, 2)}-${dataHoraInicio.substr(
				0,
				2
			)}-${dataHoraInicio.substr(6)}`;

			let fixDate = eventDate.replace('-', '/').replace('-', '/');

			const initialDate =
				diaInteiro === true
					? new Date(`${fixDate}`).setHours(0, 0, 0)
					: new Date(`${fixDate} ${dataHora}`);

			if (diaInteiro == true || dataHora == '') {
				dataHora = '23:59:59';
			}

			const finalDate = new Date(`${fixDate} ${dataHora}`);

			const HoraAtual = new Date();

			HoraAtual.setHours(HoraAtual.getHours());

			const hour = parseInt(dataHora.substr(0, 2), 10);

			if (hour >= 23) finalDate.setHours(23, 59);
			else if (diaInteiro) {
				finalDate.setHours(23, 59);
			} else {
				finalDate.setHours(endHour.substr(0, 2), endHour.substr(3, 2));
			}

			if (!$scope.validationHours(initialDate, finalDate, form)) return;

			const event = {
				titulo,
				dataHoraInicio: moment(initialDate).format('YYYY-MM-DDTHH:mm:ss'),
				dataHoraFim: moment(finalDate).format('YYYY-MM-DDTHH:mm:ss'),
				idAgenda: $rootScope.idAgenda
					? $rootScope.idAgenda
					: $scope.agendas.getItems()[0].id,
				diaInteiro,
				idOpcaoLembreteAgenda,
				idRepetEventoAgenda,
				importante,
				localizacao,
				idProcesso,
				observacao: $rootScope.formCreatePrazo.taskToEdit.observacao,
				idTipoEventoAgenda,
				sincronizado: $scope.googleSync ? !sincronizado : false,
				idsMovProcessosVinculados: [
					{
						idMovProcessoCliente: idMovProcessoCliente
							? idMovProcessoCliente
							: $scope.movementInAction.idMovProcessoCliente
					}
				],
				remoto,
				presencial
			};

			if (event.sincronizado) {
				await integracaoGoogleCalendar.insertGoogleEvent(event, fields, form);
				setTimeout(() => {
					$scope.fetchProcessAccessData();
					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('createEvent')();
				}, 500);
			} else {
				delete event['eventoGoogleId'];

				$scope.sendEvent(event, fields, form);
			}
		};

		/** Cria evento de agenda com movimento */
		$scope.sendEvent = (event, fields, form) => {
			return $http({
				...helper.http(API.deadlineEvents, 'POST'),
				data: { itens: [event] },
				messageOverride: {
					success(response, notify) {
						let idTipoEventoAgenda = -3;

						if (
							response &&
							response.data &&
							response.data.itens &&
							response.data.itens[0] &&
							response.data.itens[0].idTipoEventoAgenda
						) {
							idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
						}

						let nameType =
							idTipoEventoAgenda == -3
								? 'Compromisso'
								: idTipoEventoAgenda == -1
								? 'Tarefa'
								: 'Prazo';

						notify.success(
							`${nameType} cadastrad${
								idTipoEventoAgenda == -1 ? 'a' : 'o'
							} com sucesso.`
						);
					}
				}
			})
				.then(() => {
					$scope.fetchProcessAccessData();

					fields.map(inputKey =>
						helper.defer(() => {
							const $control = form[inputKey];

							if ($control) {
								switch (inputKey) {
									case 'idRepetEventoAgenda':
									case 'idOpcaoLembreteAgenda':
										$control.$setViewValue(-1);
										break;
									case 'idTipoCompromisso':
										$control.$setViewValue('');
										$control.$$ngModelSet('');
										$control.$$setModelValue('');
										break;
									case 'diaInteiro':
										$control.$setViewValue(false);
										$control.$$ngModelSet(false);
										$control.$$setModelValue(false);
										break;
									case 'dataHoraInicio':
										$control.$setViewValue(moment().format('DD/MM/YYYY'));
										break;
									case 'idTipoEventoAgenda':
									case 'idMovProcessoCliente':
										break;
									default:
										$control.$setViewValue('');
										break;
								}

								$control.$render();
							}
						})
					);

					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('createEvent')();

					$('#modalCreateAgendaEventComponent').modal('hide');
				})
				.finally(() => ($rootScope.creationEventLoading = false));
		};

		$scope.validationHours = (sDate, eDate) => {
			const startDate = moment(sDate);
			const endDate = moment(eDate);

			if (!startDate.isValid() || !endDate.isValid()) {
				notification.danger('Informe horários válidos para o compromisso.');

				$rootScope.creationEventLoading = false;

				return false;
			}

			if (endDate.isSameOrBefore(startDate)) {
				notification.danger(
					'Hora final cadastrada no compromisso não pode ser menor ou igual à hora inicial!'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			const diffInMinutes = endDate.diff(startDate, 'minutes');

			if (diffInMinutes < 15) {
				notification.danger(
					'O intervalo mínimo entre o horário de início e fim é de 15 minutos.'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			return true;
		};

		$scope.recordIntegration = async () => {
			//Recupera dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			//aqui google agenda
			if (!$scope.dataSync)
				await integracaoGoogleCalendar.permissionIntegracao();
			//Recupera os dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			$rootScope.sincronizacaoError =
				$scope.dataSync && !!$scope.dataSync.error;
			if ($scope.dataSync && $scope.dataSync.sincronizado) {
				$rootScope.emailGoogleAccount = true;
				$rootScope.emailGoogle = $scope.dataSync.email;
				$scope.sync = true;
			} else {
				$rootScope.emailGoogleAccount = $rootScope.sincronizacaoError
					? true
					: false;
				$rootScope.emailGoogle = false;
			}
			if ($rootScope.sincronizacaoError)
				$('#modalDisabledGoogleCalendarError').modal('show');
		};

		$scope.recordIntegration();

		$timeout(() => {
			$('#modalRecoverPastDeadlinesOneComponent').on(
				'hidden.bs.modal',
				function() {
					if ($rootScope.recoverPastDeadlinesClosingFromChoice) {
						$scope.sync = false;

						return;
					}

					$scope.syncGoogleEventsSchedule();

					if ($rootScope.formCreatePrazo.modalOpen == 'modalSync') {
						$('#modalSyncAgenda').modal('show');
					} else if ($rootScope.formCreatePrazo.modalOpen == 'modalCreate') {
						$('#modalCreateAgendaEventComponent').modal('show');
					}
					$scope.sync = false;
				}
			);
		}, 5000);

		/** verifica se esta sincronizado com o google agenda */
		$scope.checkSyncDeadlines = async (fn, movement) => {
			$scope.closeAllMovements();

			if (movement && movement.idAndamentoProcesso) {
				$rootScope.formCreatePrazo.taskToEdit.processo = {
					id: $scope.idProcesso,
					nome: $scope.pastaUsuarioCliente || $scope.numeroProcesso,
					fixado: true
				};
			}

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				//Variavel que guarda se ta sincronizado ou não
				$scope.googleSync = dataSync.sincronizado;
				//Guarda intimação a ser vinculada com prazo
				$scope.movementInAction = movement;
				$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
					{
						idMovProcessoCliente: $scope.movementInAction.idMovProcessoCliente
					}
				];
				//Variavel que guarda se ta sincronizado ou não, de forma geral '$rootScope'
				$rootScope.noSync = !dataSync.sincronizado ? true : false;

				//Verifica se e para mostrar mensagem de sincronização
				const showMessage = !integracaoGoogleCalendar.notAgainSincGoogleAgenda();

				if (!$scope.googleSync && showMessage)
					$('#modalSyncAgenda').modal('show');
				else {
					$scope.modalAddEvent();

					fn(movement);
				}
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				$scope.guardDataPrazos = {
					func: fn,
					mov: movement
				};
			}
		};

		//Dessincroniza quando da erro na sincronização
		$scope.disconnectSyncError = async () => {
			$scope.loadingDisconnectError = true;

			let dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendarError').modal('hide');

			$scope.loadingDisconnectError = false;
			$rootScope.sincronizacaoError = false;

			$scope.checkSyncDeadlines(
				$scope.guardDataPrazos.func,
				$scope.guardDataPrazos.mov
			);
		};

		/************* METODO PARA PASSAR EVENTO PRA SINCRONIZADO *************/
		$scope.modalAddEvent = () => {
			$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
		};
		/******************************** FIM ********************************/

		$scope.checkGoogleSync = () => ($scope.googleSync = true);

		$scope.showAgain = localStorage.getItem('showSyncMessage') || true;

		/** Abre modal de criação de agenda */
		$scope.openCreateAgendaEventModal = movement => {
			if (
				// permissions.has('recordSchedule') &&
				$scope.agendas.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				!$rootScope.idAgenda && $scope.recordAgendas($scope.agendas);
				$scope.recordEventsTypes($scope.eventsTypes);
			}
			$scope.movementsPrazo = { ...movement };
			$('#modalCreateAgendaEventComponent').modal('show');
		};

		/** OBSERVAÇÕES */
		$scope.editingObservation = null;

		$scope.deletingObservation = null;

		$scope.searchedObservations = false;

		$scope.loadingObservations = false;

		$scope.observationPagination = {
			paginaAtual: 0,
			paginaTotal: 0,
			registrosPorPagina: 10,
			registrosTotal: 0
		};

		$scope.observations = helper.responseStore();

		/** Oculta ou Torna visivel Observações, pasta processo */
		$scope.toggleObservation = () => {
			$scope.toggleObservations = !$scope.toggleObservations;

			if ($scope.toggleObservations && !$scope.searchedObservations)
				$scope.recordObservations($scope.observations);
		};

		/** Oculta ou Torna visivel opções de excluir/editar Observações,
		 * pasta processo
		 * */
		$scope.toggleAction = observation =>
			(observation.action = observation.action ? !observation.action : true);

		/** Método traz o registro de observações */
		$scope.recordObservations = (responseStore, page = 1) => {
			if ($scope.folderType !== -3) return;

			$scope.loadingObservations = true;

			$http({
				...helper.http(API.annotations, 'GET', {
					pasta: $stateParams.pasta
				}),
				params: {
					...helper.httpFields(['*']),
					ativo: true,
					paginaAtual: page,
					registrosPorPagina: 10
				}
			})
				.then(({ data }) => {
					if (page === 1) responseStore.setItems(data.itens);
					else responseStore.pushItems(data.itens);

					$scope.observationPagination = data.paginacao;
				})
				.finally(() => {
					$scope.searchedObservations = true;

					$scope.loadingObservations = false;
				});
		};

		/** Método que cria observação */
		$scope.createObservation = (observation, responseStore) => {
			$scope.printing = true;

			$http({
				...helper.http(API.annotations, 'POST', {
					pasta: $stateParams.pasta
				}),
				data: { ...observation },
				messageOverride: {
					success(response, notify) {
						notify.success('Observação adicionada!');
					},
					error(response, notify) {
						notify.success('Observação não adicionada!');
					}
				}
			}).then(({ data }) => {
				responseStore.unshiftItems(data.itens);
				observation.anotacao = '';
				$scope.$resetFormValidation('formCreateObservation')();

				$timeout(() => {
					const observationField = document.getElementById('anotacao');

					if (observationField) observationField.focus();
				});

				$scope.printing = false;
			});
		};

		/** Método que edita observação */
		$scope.editAnnotation = (observation, responseStore) => {
			$http({
				...helper.http(API.annotations, 'PUT', {
					pasta: $stateParams.pasta,
					id: observation.id
				}),
				data: { anotacao: observation.anotacao },
				messageOverride: {
					success(response, notify) {
						notify.success('Observação editada!');
					},
					error(response, notify) {
						notify.success('Observação não editada!');
					}
				}
			})
				.then(({ data }) => {
					// Atualiza a anotação na lista diretamente pela responseStore
					responseStore.updateItem(data.itens[0], 'id', observation.id);

					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('editObservation')();
				})
				.catch(() => (observation.anotacao = observation.originalText))
				.finally(() => {
					observation.action = false;

					$scope.editingObservation = null;
				});
		};

		/** Método que prepara observação pra edição */
		$scope.setEditingObservation = observation => {
			observation.action = false;

			observation.originalText = observation.anotacao;

			$scope.editingObservation = Object.assign({}, observation);

			$timeout(() => {
				const observationField = document.getElementById(
					`editMovimentTextObservations-${observation.id}`
				);

				if (observationField) observationField.focus();
			});
		};

		/** Método que cancela edição de observação */
		$scope.cancelEditingObservation = observation => {
			observation.action = false;

			$scope.editingObservation = null;

			observation.anotacao = observation.originalText;

			$timeout(() => {
				const createObservationField = document.getElementById('anotacao');

				if (createObservationField) createObservationField.focus();
			});
		};

		/** Método que prepara observação para exclusão */
		$scope.setDeletingObservation = observation => {
			observation.action = false;

			$scope.deletingObservation = observation;

			$('#modalInactivateObservation').modal('show');
		};

		/** Método de deleta observação */
		$scope.deleteObservation = responseStore => {
			const observation = $scope.deletingObservation;

			$http({
				...helper.http(API.annotations, 'inativar', {
					pasta: $stateParams.pasta,
					id: observation.id
				}),
				method: 'PUT',
				data: { anotacao: observation.anotacao },
				messageOverride: {
					success(response, notify) {
						notify.success('Observação excluída!');
					},
					error(response, notify) {
						notify.success('Observação não excluída!');
					}
				}
			})
				.then(({ data }) => responseStore.removeItems(data.itens, 'id'))
				.finally(() => {
					$scope.deletingObservation = null;

					$('#modalInactivateObservation').modal('hide');
				});
		};

		/*************************** AÇÕES ****************************************/

		$scope.actions = (mov, i) => {
			if (!mov.acao) {
				$scope.movements.forEach((m, index) => {
					if (m.acao) {
						m.acao = false;
						$scope.actionElements('close', index);
					}
				});

				mov.acao = true;

				$scope.actionElements('open', i);
				$scope.closeAction();
			} else {
				mov.acao = false;
				$scope.actionElements('close', i);
			}
		};

		/** Método que fecha filtro de tribunais personalidado */
		$scope.closeAction = () => {
			$(document).on('click', function(e) {
				if (!$(e.target).is('.card__action')) {
					if ($scope.openCardAction) {
						var i = 0;

						$scope.movements.forEach((m, index) => {
							if (m.acao) {
								m.acao = false;
								i = index;
							}
						});

						$scope.actionElements('close', i);
					}
				}
			});
		};

		$scope.actionElements = (action, i) => {
			let element = document.getElementById(`action${i}`);
			let more = document.getElementById(`more${i}`);
			let close = document.getElementById(`close${i}`);

			element.style.display = action == 'open' ? 'block' : 'none';

			action == 'open'
				? ((more.style.display = 'none'), (close.style.display = 'block'))
				: ((close.style.display = 'none'), (more.style.display = 'block'));

			$scope.openCardAction = action == 'open' ? true : false;
		};

		/** Método que fecha filtro de tribunais personalidado */
		$scope.closeActionMobile = () => {
			$(document).on('click', function(e) {
				if (!$(e.target).is('.card__action-mobile')) {
					if ($scope.openCardAction) {
						var i = 0;

						$scope.movements.forEach((m, index) => {
							if (m.acao) {
								m.acao = false;
								i = index;
							}
						});

						$scope.actionElementsMobile('close', i);
					}
				}
			});
		};

		$scope.actionElementsMobile = (action, i) => {
			let element = document.getElementById(`action-mobile${i}`);
			let more = document.getElementById(`more-mobile${i}`);
			let close = document.getElementById(`close-mobile${i}`);

			element.style.display = action == 'open' ? 'block' : 'none';

			action == 'open'
				? ((more.style.display = 'none'), (close.style.display = 'block'))
				: ((close.style.display = 'none'), (more.style.display = 'block'));

			$scope.openCardAction = action == 'open' ? true : false;
		};

		$scope.closeAllMovements = () => {
			$scope.movements.forEach((m, index) => {
				if (m.acao) {
					m.acao = false;
					$scope.actionElements('close', index);
					$scope.actionElementsMobile('close', index);
				}
			});
		};

		$scope.returnResume = resume => {
			const str = resume;
			var termo = $scope.stateParamsFilter.pesquisa;

			if (!termo) return resume;

			let str2 = str
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');
			let termo2 = termo
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');

			function hasInclude() {
				if (str2.includes(termo2)) return true;
				else return false;
			}

			if (!hasInclude()) {
				for (let index = 0; termo.length > 0; index++) {
					const ultima = termo.substring(termo.lastIndexOf(' ') + 1);

					termo = termo.substring(0, termo.length - ultima.length - 1);

					if (hasInclude()) break;
				}

				if (!hasInclude()) return resume;
			}

			if (!hasInclude()) return resume;

			var positionInitial = str2.indexOf(termo2);

			var output = [
				str.slice(0, positionInitial),
				'<span class="termResume">',
				str.slice(positionInitial)
			].join('');

			let output2 = output
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');

			var positionEnd = output2.indexOf(termo2) + termo.length;

			output = [
				output.slice(0, positionEnd),
				'</span>',
				output.slice(positionEnd)
			].join('');

			return output;
		};

		$scope.checkDisabled = () => {
			if ($scope.hasNotList) return true;

			return false;
		};

		$scope.checkDisabledDetails = () => {
			if ($scope.hasNotListDetails) return true;

			return false;
		};

		$scope.onInit();

		$scope.view = () => {
			let local = window.location.pathname.includes('processos');

			if ($scope.processesList && $scope.processesList.length == 0 && local)
				return true;
		};

		$scope.preventDefaultEsc = event => {
			event.preventDefault();
		};
	}
]);

export default controller;
